webpackJsonp([5],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fixit = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Fixit, _React$Component);

  function Fixit(props) {
    (0, _classCallCheck3.default)(this, Fixit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Fixit.__proto__ || (0, _getPrototypeOf2.default)(Fixit)).call(this, props));

    _this._handleScroll = function () {
      window.requestAnimationFrame(function () {
        _this.setState({ scrollY: window.scrollY });
      });
    };

    _this.state = { scrollY: 0 };
    return _this;
  }

  (0, _createClass3.default)(Fixit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this._handleScroll);
      this._handleScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this._handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          transitionHeight = _props.transitionHeight;
      var scrollY = this.state.scrollY;


      var progress = scrollY > 0 ? Math.min(1, scrollY / transitionHeight) : 0;

      var originalStyles = (0, _glamor.style)({
        visibility: 'hidden',
        zIndex: -1,
        position: 'relative'
      });

      var cloneStyles = (0, _glamor.style)({
        transform: 'translate3d(0,0,0)',
        zIndex: 10,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
      });

      var styles = void 0;
      var isFixed = void 0;

      if (scrollY <= 0) {
        styles = cloneStyles;
        isFixed = false;
      } else {
        styles = (0, _glamor.merge)(cloneStyles, (0, _glamor.style)({
          position: 'fixed'
        }));
        isFixed = true;
      }

      return (0, _jsx3.default)('div', {}, void 0, _react2.default.createElement(
        'div',
        (0, _extends3.default)({ 'aria-hidden': true }, originalStyles),
        children(false, 0)
      ), _react2.default.createElement(
        'div',
        styles,
        children(isFixed, progress)
      ));
    }
  }]);
  return Fixit;
}(_react2.default.Component), _class.defaultProps = {
  transitionHeight: 100
}, _temp);
exports.default = Fixit;

/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

var _reactMotion = __webpack_require__(999);

var _NotificationsProvider = __webpack_require__(973);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsList = function (_React$Component) {
  (0, _inherits3.default)(NotificationsList, _React$Component);

  function NotificationsList() {
    (0, _classCallCheck3.default)(this, NotificationsList);
    return (0, _possibleConstructorReturn3.default)(this, (NotificationsList.__proto__ || (0, _getPrototypeOf2.default)(NotificationsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotificationsList, [{
    key: 'willLeave',
    value: function willLeave() {
      return {
        opacity: (0, _reactMotion.spring)(0),
        marginTop: (0, _reactMotion.spring)(-58),
        marginLeft: (0, _reactMotion.spring)(10)
      };
    }
  }, {
    key: 'willEnter',
    value: function willEnter() {
      return {
        opacity: 0,
        marginTop: 5,
        marginLeft: 300
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          notifications = _props.notifications,
          removeNotification = _props.removeNotification;


      return (0, _jsx3.default)(_reactMotion.TransitionMotion, {
        willLeave: this.willLeave,
        willEnter: this.willEnter,
        styles: notifications.map(function (notification) {
          return {
            key: notification.id,
            data: notification,
            style: {
              opacity: (0, _reactMotion.spring)(1),
              marginTop: 5,
              marginLeft: (0, _reactMotion.spring)(10)
            }
          };
        })
      }, void 0, function (interpolatedStyles) {
        return _react2.default.createElement(
          'ul',
          (0, _glamor.css)({
            position: 'fixed',
            top: 62,
            right: 24,
            zIndex: 99999,
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            width: 300,
            overflowX: 'hidden'
          }),
          interpolatedStyles.map(function (config) {
            var color = config.data.status === 'error' ? '#d81f2a' : '#266e1c';
            return _react2.default.createElement(
              'li',
              (0, _extends3.default)({
                key: config.key,
                style: config.style
              }, (0, _glamor.css)({
                fontSize: 14,
                backgroundColor: '#fff',
                padding: 16,
                color: color,
                borderLeft: '4px solid ' + color,
                margin: 0,
                marginBottom: 16,
                marginRight: 10,
                width: 280,
                userSelect: 'none',
                cursor: 'pointer',
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)'
              }), {
                onClick: function onClick() {
                  return removeNotification(config.data.id);
                } }),
              config.data.content
            );
          })
        );
      });
    }
  }]);
  return NotificationsList;
}(_react2.default.Component);

exports.default = (0, _NotificationsProvider.withNotifications)(NotificationsList);

/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactBroadcast = __webpack_require__(980);

var _NotificationsList = __webpack_require__(1001);

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsListWrapper = function () {
  function NotificationsListWrapper(props) {
    return (0, _jsx3.default)(_reactBroadcast.Subscriber, {
      channel: 'notifications'
    }, void 0, function (notifications) {
      return (0, _jsx3.default)(_NotificationsList2.default, {
        notifications: notifications
      });
    });
  }

  return NotificationsListWrapper;
}();

exports.default = NotificationsListWrapper;

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

var _reactIntl = __webpack_require__(188);

var _Cross = __webpack_require__(1005);

var _Cross2 = _interopRequireDefault(_Cross);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_Cross2.default, {
  fill: 'white'
});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'AppBanner.openApp',
  description: 'Call to action on app banner, MUST BE SMALL',
  defaultMessage: 'Open in app'
});

var AppBanner = function (_React$Component) {
  (0, _inherits3.default)(AppBanner, _React$Component);

  function AppBanner() {
    (0, _classCallCheck3.default)(this, AppBanner);
    return (0, _possibleConstructorReturn3.default)(this, (AppBanner.__proto__ || (0, _getPrototypeOf2.default)(AppBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppBanner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          link = _props.link,
          open = _props.open,
          close = _props.close;


      var deeplinkPath = !!this.props.path;

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          display: open && deeplinkPath ? 'flex' : 'none',
          visibility: open && deeplinkPath ? 'visible' : 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          width: '10em',
          marginLeft: '-5em',
          bottom: '20px',
          left: '50%',
          color: 'white',
          backgroundColor: '#D81F2A',
          border: '1px solid #B71922',
          borderRadius: '30px',
          zIndex: '9999'
        }),
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({ href: 'javascript:;',
            onClick: close
          }, (0, _glamor.css)({
            display: 'block',
            width: 12,
            height: 14,
            marginRight: '13px'
          })),
          _ref
        ),
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({}, (0, _glamor.css)({
            display: 'block',
            padding: '10px 0',
            fontSize: 14,
            textAlign: 'center',
            textDecoration: 'none',
            color: 'inherit'
          }), {
            href: link }),
          _ref2
        )
      );
    }
  }]);
  return AppBanner;
}(_react2.default.Component);

exports.default = AppBanner;

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(410);

var _overlays = __webpack_require__(413);

var _deeplinks = __webpack_require__(974);

var _AppBanner = __webpack_require__(1003);

var _AppBanner2 = _interopRequireDefault(_AppBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeeplinkBanner = function (_React$Component) {
  (0, _inherits3.default)(DeeplinkBanner, _React$Component);

  function DeeplinkBanner(props) {
    (0, _classCallCheck3.default)(this, DeeplinkBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeeplinkBanner.__proto__ || (0, _getPrototypeOf2.default)(DeeplinkBanner)).call(this, props));

    _this.state = { mounted: false };
    return _this;
  }

  (0, _createClass3.default)(DeeplinkBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userAgent = _props.userAgent,
          overlays = _props.overlays,
          onClose = _props.onClose;
      var mounted = this.state.mounted;


      if (mounted && (0, _deeplinks.isBannerPlatform)(userAgent.platform)) {
        return _react2.default.createElement(_AppBanner2.default, (0, _extends3.default)({ close: onClose, open: overlays.open }, overlays.deeplinkBanner));
      }
      return null;
    }
  }]);
  return DeeplinkBanner;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var userAgent = _ref.userAgent,
      overlays = _ref.overlays;
  return {
    userAgent: userAgent,
    overlays: overlays
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _overlays.closeDeeplinkBanner)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeeplinkBanner);

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === undefined ? 0 : _ref$rotate,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;
  return (0, _jsx3.default)('div', {
    style: { transform: 'rotate(' + rotate + 'deg) scale(' + scale + ')' }
  }, void 0, (0, _jsx3.default)('svg', {
    viewBox: '0 0 40 40'
  }, void 0, (0, _jsx3.default)('polygon', {
    fill: fill,
    points: '25.0007575 20.0007575 40 5.00265103 35 3.55271368e-15 20 15 5 3.55271368e-15 -1.42108547e-14 5.00265103 14.9992425 20.0007575 0 35 5 40 20 25.0011362 35 40 40 35 25.0007575 20.0007575'
  })));
};

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDimensions = function getDimensions() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

var FullScreen = function (_React$Component) {
  (0, _inherits3.default)(FullScreen, _React$Component);

  function FullScreen(props) {
    (0, _classCallCheck3.default)(this, FullScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullScreen.__proto__ || (0, _getPrototypeOf2.default)(FullScreen)).call(this, props));

    _this.handleResize = function () {
      _this.setState(getDimensions());
    };

    _this.state = getDimensions();
    return _this;
  }

  (0, _createClass3.default)(FullScreen, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.style.overflowY = 'hidden';
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.body.style.overflowY = 'scroll';
      }
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
        width: this.state.width,
        height: this.state.height
      });
    }
  }]);
  return FullScreen;
}(_react2.default.Component);

exports.default = FullScreen;

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(969);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _locale = __webpack_require__(416);

var _reactRedux = __webpack_require__(410);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(_ref) {
  var locale = _ref.locale;

  return {
    language: locale.language,
    availableLanguages: locale.availableLanguages
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(event) {
      return dispatch((0, _locale.changeLanguage)(event.target.value));
    }
  };
}

/**
* A component used in development to switch locales, and
* should never be visible in a production build, right?
*/
function LocaleSwitcher(_ref2) {
  var language = _ref2.language,
      availableLanguages = _ref2.availableLanguages,
      onChange = _ref2.onChange;

  var buttonStyle = (0, _glamor.style)({
    position: 'relative',
    color: '#666',
    display: 'inlineBlock',
    margin: '0 5px',
    border: 0,
    padding: 0,
    fontWeight: 'normal',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    background: 'none',
    outline: 'none',
    fontSize: 14
  });

  var hoverStyle = (0, _glamor.hover)({ textDecoration: 'underline', color: '#000' });

  var selectedButtonStyle = (0, _glamor.style)({
    color: '#000',
    fontWeight: 'bold',
    textDecoration: 'underline'
  });

  return _react2.default.createElement(
    'div',
    (0, _glamor.style)({ display: 'inlineBlock' }),
    '(',
    availableLanguages.map(function (lang) {
      var styles = [buttonStyle, hoverStyle].concat((0, _toConsumableArray3.default)(language === lang.value ? [selectedButtonStyle] : []));

      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({ key: lang.value, value: lang.value, onClick: onChange }, (0, _glamor.merge)(styles)),
        lang.name
      );
    }),
    ')'
  );
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocaleSwitcher);

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(188);

var _glamor = __webpack_require__(273);

var _LocaleSwitcher = __webpack_require__(1007);

var _LocaleSwitcher2 = _interopRequireDefault(_LocaleSwitcher);

var _Container = __webpack_require__(963);

var _Container2 = _interopRequireDefault(_Container);

var _Link = __webpack_require__(960);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.aboutLabel',
  description: 'About Label',
  defaultMessage: 'About'
});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.jobsLabel',
  description: 'Jobs Label',
  defaultMessage: 'Jobs'
});

var _ref3 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
  rel: 'noopener',
  target: '_blank',
  href: 'http://blog.depop.com/'
}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.blogLabel',
  description: 'Blog Label',
  defaultMessage: 'Blog'
})));

var _ref4 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
  rel: 'noopener',
  target: '_blank',
  href: 'http://help.depop.com/'
}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.supportLabel',
  description: 'Support Label',
  defaultMessage: 'Support'
})));

var _ref5 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
  rel: 'noopener',
  target: '_blank',
  href: 'https://instagram.com/depop/'
}, void 0, 'Instagram'));

var _ref6 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
  rel: 'noopener',
  target: '_blank',
  href: 'https://twitter.com/depop/'
}, void 0, 'Twitter'));

var _ref7 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
  rel: 'noopener',
  target: '_blank',
  href: 'https://facebook.com/depop'
}, void 0, 'Facebook'));

var _ref8 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_LocaleSwitcher2.default, {}));

var Footer = function () {
  function Footer(props) {
    return _react2.default.createElement(
      'nav',
      (0, _extends3.default)({}, (0, _glamor.style)({
        display: 'none'
      }), (0, _glamor.media)('(min-width: 701px)', {
        display: 'block',
        position: 'fixed',
        bottom: 0,
        width: '100%',
        margin: 0,
        background: '#fff',
        zIndex: 10
      })),
      (0, _jsx3.default)(_Container2.default, {}, void 0, _react2.default.createElement(
        'ul',
        (0, _extends3.default)({}, (0, _glamor.style)({
          display: 'inline-block',
          margin: '0 auto',
          listStyleType: 'none'
        }), (0, _glamor.$)('> li', {
          display: 'inline-block',
          marginRight: '1em',
          fontSize: 14
        }), (0, _glamor.$)('> li a', {
          color: 'inherit',
          textDecoration: 'none',
          fontWeight: 'bold',
          cursor: 'pointer'
        }), (0, _glamor.$)('> li:hover a', {
          textDecoration: 'underline'
        })),
        (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_Link2.default, {
          to: { pathname: '/about/' }
        }, void 0, _ref)),
        (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_Link2.default, {
          to: { pathname: '/about/jobs/' }
        }, void 0, _ref2)),
        _ref3,
        _ref4,
        _ref5,
        _ref6,
        _ref7,
        _ref8
      ))
    );
  }

  return Footer;
}();

exports.default = Footer;

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(273);

var _LogoutButton = __webpack_require__(977);

var _LogoutButton2 = _interopRequireDefault(_LogoutButton);

var _Link = __webpack_require__(960);

var _Link2 = _interopRequireDefault(_Link);

var _FullScreen = __webpack_require__(1006);

var _FullScreen2 = _interopRequireDefault(_FullScreen);

var _reactIntl = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSTAGRAM_LINK = 'https://instagram.com/depop/';
var TWITTER_LINK = 'https://twitter.com/depop/';
var FACEBOOK_LINK = 'https://facebook.com/depop';

var menuItemStyles = {
  fontSize: '20px',
  fontWeight: 'bold',
  margin: '1em 0'
};

var rootStyleBasic = {
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: '20',
  width: '100vw',
  height: '100%',
  padding: '0 20px 20px',
  backgroundColor: 'white'
};

var inFromRight = (0, _glamor.keyframes)({
  'from': { transform: 'translateX(100vw)' },
  'to': { transform: 'translateX(0)' }
});

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.profileLabel',
  description: 'Displayed on a link to a user\'s own profile',
  defaultMessage: 'Profile'
});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.downloadLabel',
  description: 'Download Label',
  defaultMessage: 'Download App'
});

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.aboutLabel',
  description: 'About Label',
  defaultMessage: 'About'
});

var _ref4 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.jobsLabel',
  description: 'Jobs Label',
  defaultMessage: 'Jobs'
});

var _ref5 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.blogLabel',
  description: 'Blog Label',
  defaultMessage: 'Blog'
});

var _ref6 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.supportLabel',
  description: 'Support Label',
  defaultMessage: 'Support'
});

var _ref7 = (0, _jsx3.default)(_LogoutButton2.default, {});

var FullPageNav = function (_React$Component) {
  (0, _inherits3.default)(FullPageNav, _React$Component);

  function FullPageNav() {
    (0, _classCallCheck3.default)(this, FullPageNav);
    return (0, _possibleConstructorReturn3.default)(this, (FullPageNav.__proto__ || (0, _getPrototypeOf2.default)(FullPageNav)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullPageNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewer = _props.viewer,
          toggle = _props.toggle,
          isExpanded = _props.isExpanded,
          toggleDownloadAppModal = _props.toggleDownloadAppModal;
      var currentUser = viewer.currentUser;


      var rootStyle = isExpanded ? (0, _extends3.default)({}, rootStyleBasic, {
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: 'white',
        animationName: inFromRight,
        animationDuration: '.15s',
        animationFillMode: 'forwards',
        animationTimingFunction: 'ease-in-out'
      }) : rootStyleBasic;

      return (0, _jsx3.default)(_FullScreen2.default, {}, void 0, _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, (0, _glamor.style)(rootStyle), { onClick: toggle }),
        _react2.default.createElement(
          'ul',
          (0, _glamor.style)({
            width: '100%',
            margin: '-20px auto 0',
            listStyle: 'none'
          }),
          currentUser && _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            (0, _jsx3.default)(_Link2.default, {
              style: { color: 'inherit', textDecoration: 'none' },
              to: { pathname: '/' + currentUser.username, state: { userId: currentUser.publicId } }
            }, void 0, _ref)
          ),
          !currentUser && _react2.default.createElement(
            'li',
            (0, _extends3.default)({}, (0, _glamor.style)(menuItemStyles), (0, _glamor.$)('a', { color: 'inherit', textDecoration: 'none' }), (0, _glamor.$)('a:hover', { textDecoration: 'underline' })),
            (0, _jsx3.default)('span', {
              style: { cursor: 'pointer' },
              onClick: toggleDownloadAppModal
            }, void 0, _ref2)
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            (0, _jsx3.default)(_Link2.default, {
              style: { color: 'inherit', textDecoration: 'none' },
              to: { pathname: '/about/' }
            }, void 0, _ref3)
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            (0, _jsx3.default)(_Link2.default, {
              style: { color: 'inherit', textDecoration: 'none' },
              to: { pathname: '/about/jobs/' }
            }, void 0, _ref4)
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _react2.default.createElement(
              'a',
              (0, _extends3.default)({ rel: 'noopener',
                target: '_blank',
                href: 'http://blog.depop.com/'
              }, (0, _glamor.style)({ color: 'inherit', textDecoration: 'none' })),
              _ref5
            )
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _react2.default.createElement(
              'a',
              (0, _extends3.default)({
                rel: 'noopener',
                target: '_blank',
                href: 'http://help.depop.com/'
              }, (0, _glamor.style)({ color: 'inherit', textDecoration: 'none' })),
              _ref6
            )
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _react2.default.createElement(
              'a',
              (0, _extends3.default)({
                rel: 'noopener',
                target: '_blank',
                href: INSTAGRAM_LINK
              }, (0, _glamor.style)({ color: 'inherit', textDecoration: 'none' })),
              'Instagram'
            )
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _react2.default.createElement(
              'a',
              (0, _extends3.default)({
                rel: 'noopener',
                target: '_blank',
                href: TWITTER_LINK
              }, (0, _glamor.style)({ color: 'inherit', textDecoration: 'none' })),
              'Twitter'
            )
          ),
          _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _react2.default.createElement(
              'a',
              (0, _extends3.default)({
                rel: 'noopener',
                target: '_blank',
                href: FACEBOOK_LINK
              }, (0, _glamor.style)({ color: 'inherit', textDecoration: 'none' })),
              'Facebook'
            )
          ),
          currentUser && _react2.default.createElement(
            'li',
            (0, _glamor.style)(menuItemStyles),
            _ref7
          )
        )
      ));
    }
  }]);
  return FullPageNav;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(FullPageNav, {
  fragments: {
    viewer: function viewer() {
      return function () {
        return {
          children: [{
            children: [{
              fieldName: 'publicId',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }, {
              fieldName: 'username',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'FullPageNav_ViewerRelayQL',
          type: 'Viewer'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRedux = __webpack_require__(410);

var _GlobalHeader = __webpack_require__(1011);

var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);

var _Footer = __webpack_require__(1008);

var _Footer2 = _interopRequireDefault(_Footer);

var _FullPageNav = __webpack_require__(1009);

var _FullPageNav2 = _interopRequireDefault(_FullPageNav);

var _LazyModal = __webpack_require__(970);

var _LazyModal2 = _interopRequireDefault(_LazyModal);

var _Fixit = __webpack_require__(1000);

var _Fixit2 = _interopRequireDefault(_Fixit);

var _recompose = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_Footer2.default, {});

var AppNavigation = function (_React$Component) {
  (0, _inherits3.default)(AppNavigation, _React$Component);

  function AppNavigation(props) {
    (0, _classCallCheck3.default)(this, AppNavigation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppNavigation.__proto__ || (0, _getPrototypeOf2.default)(AppNavigation)).call(this, props));

    _this.toggleFullPageNav = function () {
      var fullPageNavExpanded = _this.state.fullPageNavExpanded;

      if (fullPageNavExpanded) {
        _this.setState({
          fullPageNavExpanded: false
        });
      } else {
        _this.setState({
          fullPageNavExpanded: true,
          searchExpanded: false,
          isDownloadAppVisible: false
        });
      }
    };

    _this.hideDownloadApp = function () {
      _this.setState(function (state) {
        if (state.isDownloadAppVisible) {
          return { isDownloadAppVisible: false };
        }
      });
    };

    _this.showDownloadApp = function () {
      _this.setState(function (state) {
        if (!state.isDownloadAppVisible) {
          return {
            isDownloadAppVisible: true,
            fullPageNavExpanded: false,
            searchExpanded: false
          };
        }
      });
    };

    _this.toggleSearch = function () {
      var searchExpanded = _this.state.searchExpanded;

      if (searchExpanded) {
        _this.setState({
          searchExpanded: false
        });
      } else {
        _this.setState({
          fullPageNavExpanded: false,
          searchExpanded: true,
          isDownloadAppVisible: false
        });
      }
    };

    _this.handleSearch = function () {
      _this.setState({
        searchExpanded: false
      });
    };

    _this.state = {
      fullPageNavExpanded: false,
      searchExpanded: false,
      isDownloadAppVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(AppNavigation, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          showSearch = _props.showSearch,
          hideFooter = _props.hideFooter;
      var _state = this.state,
          fullPageNavExpanded = _state.fullPageNavExpanded,
          searchExpanded = _state.searchExpanded,
          isDownloadAppVisible = _state.isDownloadAppVisible;
      var toggleSearch = this.toggleSearch,
          toggleFullPageNav = this.toggleFullPageNav;


      return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_Fixit2.default, {}, void 0, function (isFixed, fixedProgress) {
        return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_GlobalHeader2.default, {
          toggleFullPageNav: toggleFullPageNav,
          toggleDownloadAppModal: _this2.showDownloadApp,
          toggleSearch: toggleSearch,
          searchExpanded: searchExpanded,
          showSearch: showSearch,
          onSearch: _this2.handleSearch,
          isFixed: isFixed,
          fixedProgress: fixedProgress,
          viewer: viewer
        }));
      }), fullPageNavExpanded && (0, _jsx3.default)(_FullPageNav2.default, {
        toggle: toggleFullPageNav,
        isExpanded: fullPageNavExpanded,
        toggleDownloadAppModal: this.showDownloadApp,
        viewer: viewer
      }), (0, _jsx3.default)(_LazyModal2.default, {
        isOpened: isDownloadAppVisible,
        onClose: this.hideDownloadApp,
        load: function load() {
          return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1046)).then(function (module) {
            return module.default;
          });
        },
        render: function render(TextMeTheApp) {
          return (0, _jsx3.default)(TextMeTheApp, {
            onClose: _this2.hideDownloadApp
          });
        }
      }), !hideFooter && _ref);
    }
  }]);
  return AppNavigation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var userAgent = _ref2.userAgent,
      overlays = _ref2.overlays;
  return {
    userAgent: userAgent,
    overlays: overlays
  };
};

var connectedView = (0, _reactRedux.connect)(mapStateToProps)(AppNavigation);

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(connectedView), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            children: [{
              fieldName: 'publicId',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }, {
              fieldName: 'username',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'AppNavigation_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_FullPageNav2.default.getFragment('viewer'), _GlobalHeader2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactIntl = __webpack_require__(188);

var _glamor = __webpack_require__(273);

var _Logo = __webpack_require__(990);

var _Logo2 = _interopRequireDefault(_Logo);

var _Container = __webpack_require__(963);

var _Container2 = _interopRequireDefault(_Container);

var _Link = __webpack_require__(960);

var _Link2 = _interopRequireDefault(_Link);

var _LazyModal = __webpack_require__(970);

var _LazyModal2 = _interopRequireDefault(_LazyModal);

var _UserMenu = __webpack_require__(1013);

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _GlobalSearch = __webpack_require__(1012);

var _GlobalSearch2 = _interopRequireDefault(_GlobalSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerLinkBaseStyle = {
  marginLeft: '1em',
  textDecoration: 'none',
  color: 'inherit',
  fontWeight: 'bold',
  flexShrink: '0',
  flexGrow: '0',
  whiteSpace: 'nowrap',
  cursor: 'pointer'
};

var _ref = (0, _jsx3.default)(_Logo2.default, {});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.searchLabel',
  description: 'Search Label',
  defaultMessage: 'Search'
});

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.searchLabel',
  description: 'Search Label',
  defaultMessage: 'Search'
});

var _ref4 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.downloadLabel',
  description: 'Download Label',
  defaultMessage: 'Download App'
});

var _ref5 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.menuLabel',
  description: 'Menu Label',
  defaultMessage: 'Menu'
});

var _ref6 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.loginLabel',
  description: 'Login Label',
  defaultMessage: 'Login'
});

var GlobalHeader = function (_React$Component) {
  (0, _inherits3.default)(GlobalHeader, _React$Component);

  function GlobalHeader(props) {
    (0, _classCallCheck3.default)(this, GlobalHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalHeader.__proto__ || (0, _getPrototypeOf2.default)(GlobalHeader)).call(this, props));

    _this.showLogin = function () {
      _this.setState({ isModalVisible: true });
    };

    _this.hideLogin = function () {
      _this.setState({ isModalVisible: false });
    };

    _this.showDownloadApp = function () {
      _this.setState({ isDownloadAppVisible: true });
    };

    _this.hideDownloadApp = function () {
      _this.setState({ isDownloadAppVisible: false });
    };

    _this.state = {
      isModalVisible: false,
      isDownloadAppVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(GlobalHeader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          onSearch = _props.onSearch,
          showSearch = _props.showSearch,
          searchExpanded = _props.searchExpanded,
          toggleSearch = _props.toggleSearch,
          toggleFullPageNav = _props.toggleFullPageNav,
          toggleDownloadAppModal = _props.toggleDownloadAppModal,
          isFixed = _props.isFixed;
      var isModalVisible = this.state.isModalVisible;


      var opacity = isFixed ? 1 : 0;

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          backgroundColor: '#fff',
          fontSize: '16px',
          borderBottom: '1px solid rgba(238,238,238, ' + opacity + ')'
        }),
        (0, _jsx3.default)(_Container2.default, {}, void 0, _react2.default.createElement(
          'div',
          (0, _glamor.css)({
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
          }),
          _react2.default.createElement(
            'div',
            (0, _glamor.css)({
              marginRight: '1em',
              flexGrow: '0',
              flexShrink: '0',
              height: '27px',
              maxHeight: '27px',
              width: '80px'
            }),
            (0, _jsx3.default)(_Link2.default, {
              to: { pathname: '/' }
            }, void 0, _ref)
          ),
          showSearch && searchExpanded && (0, _jsx3.default)(_GlobalSearch2.default, {
            onSearch: onSearch,
            searchExpanded: searchExpanded,
            currentUser: viewer.currentUser,
            toggleSearch: toggleSearch
          }),
          (0, _jsx3.default)('div', {}, void 0, viewer.currentUser ? (0, _jsx3.default)(_UserMenu2.default, {
            viewer: viewer,
            showSearch: showSearch,
            user: viewer.currentUser,
            toggleFullPageNav: toggleFullPageNav,
            toggleSearch: toggleSearch,
            searchExpanded: searchExpanded
          }) : (0, _jsx3.default)('nav', {}, void 0, showSearch && !searchExpanded && !viewer.currentUser && _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.css)((0, _extends3.default)({}, headerLinkBaseStyle, {
              display: 'none'
            })), (0, _glamor.media)('(min-width: 701px)', { display: 'inline' }), {
              href: 'javascript:;',
              onClick: toggleSearch }),
            _ref2
          ), _react2.default.createElement(
            _Link2.default,
            (0, _extends3.default)({ to: '/search'
            }, (0, _glamor.css)({
              display: 'inline',
              color: 'inherit',
              fontWeight: 'bold',
              textDecoration: 'none' }), (0, _glamor.media)('(min-width: 701px)', { display: 'none' })),
            _ref3
          ), (0, _jsx3.default)('span', {}, void 0, _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.css)((0, _extends3.default)({}, headerLinkBaseStyle, {
              display: 'none'
            })), (0, _glamor.media)('(min-width: 701px)', { display: 'inline' }), {
              onClick: toggleDownloadAppModal }),
            _ref4
          )), _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.css)(headerLinkBaseStyle), (0, _glamor.media)('(min-width: 701px)', { display: 'none' }), {
              onClick: toggleFullPageNav,
              href: 'javascript:;' }),
            _ref5
          ), _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.css)(headerLinkBaseStyle), {
              onClick: this.showLogin,
              href: 'javascript:;' }),
            _ref6
          ))),
          (0, _jsx3.default)(_LazyModal2.default, {
            isOpened: isModalVisible,
            onClose: this.hideLogin,
            load: function load() {
              return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 994)).then(function (module) {
                return module.default;
              });
            },
            render: function render(Login) {
              return (0, _jsx3.default)(Login, {
                closeModal: _this2.hideLogin
              });
            }
          })
        ))
      );
    }
  }]);
  return GlobalHeader;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(GlobalHeader, {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1) {
        return {
          children: [{
            children: [].concat.apply([], [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'GlobalHeader_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_UserMenu2.default.getFragment('user'), _GlobalSearch2.default.getFragment('currentUser'));
    }
  }
});

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(273);

var _reactIntl = __webpack_require__(188);

var _qs = __webpack_require__(991);

var _qs2 = _interopRequireDefault(_qs);

var _tracking = __webpack_require__(142);

var _detectUserMention = __webpack_require__(997);

var _detectUserMention2 = _interopRequireDefault(_detectUserMention);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expandout = (0, _glamor.keyframes)({
  from: { width: '0' },
  to: { width: '100%' }
});

var messages = (0, _reactIntl.defineMessages)({
  queryPlaceholder: {
    'id': 'GlobalSearch.queryPlaceholder',
    'defaultMessage': 'Search for items'
  }
});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.closeGlobalSearch',
  description: 'Closes the global search',
  defaultMessage: 'Close'
});

var GlobalSearch = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(GlobalSearch, _React$Component);

  function GlobalSearch() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GlobalSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GlobalSearch.__proto__ || (0, _getPrototypeOf2.default)(GlobalSearch)).call.apply(_ref, [this].concat(args))), _this), _this.setInputRef = function (el) {
      _this._input = el;
    }, _this.handleSubmit = function (event) {
      event.preventDefault();

      (0, _tracking.trackProductSearch)({
        query: _this._input.value
      });

      var presentUsername = (0, _detectUserMention2.default)(_this._input.value);

      if (presentUsername) {
        _this.context.router.push({
          pathname: '/' + presentUsername
        });

        _this.props.onSearch();
      } else {
        _this.context.router.push({
          pathname: '/search/',
          search: '?' + _qs2.default.stringify({
            q: _this._input.value
          })
        });

        _this.props.onSearch();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GlobalSearch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggleSearch = _props.toggleSearch,
          intl = _props.intl;

      document.body.style.overflowY = 'scroll';

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, (0, _glamor.style)({
          margin: '-5px 0 0',
          position: 'relative',
          flexGrow: '1',
          width: '100%',
          background: 'white',
          transform: 'translateY(3px)'
        }), (0, _glamor.media)('(max-width: 700px)', { margin: '-2px 0 3px' })),
        _react2.default.createElement(
          'form',
          (0, _extends3.default)({
            action: '/search/',
            method: 'get',
            onBlur: toggleSearch,
            onSubmit: this.handleSubmit
          }, (0, _glamor.style)({
            display: 'flex',
            alignContent: 'baseline',
            justifyContent: 'flex-end'
          })),
          _react2.default.createElement('input', (0, _extends3.default)({
            name: 'q',
            autoComplete: 'off',
            ref: this.setInputRef,
            autoFocus: 'true',
            type: 'text',
            placeholder: intl.formatMessage(messages.queryPlaceholder)
          }, (0, _glamor.style)({
            padding: '3px 0',
            appearance: 'none',
            border: 'none',
            marginRight: '.5em',
            fontSize: '16px',
            fontWeight: 'bold',
            borderBottom: '1px solid black',
            borderRadius: '0'
          }), (0, _glamor.focus)({
            width: '100%',
            outline: 'none',
            fontWeight: 'normal',
            animationName: expandout,
            animationDuration: '.2s',
            animationFillMode: 'forwards'
          }))),
          _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.style)({
              appearance: 'none',
              border: '0',
              margin: '0',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              background: 'none'
            }), {
              onClick: toggleSearch }),
            _ref2
          )
        ),
        _react2.default.createElement('div', (0, _extends3.default)({
          onClick: toggleSearch
        }, (0, _glamor.style)({
          position: 'fixed',
          top: '65px',
          left: '0',
          right: '0',
          bottom: '0',
          width: '100vw',
          height: '100vh'
        })))
      );
    }
  }]);
  return GlobalSearch;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
}, _temp2);
exports.default = _reactRelay2.default.createContainer((0, _reactIntl.injectIntl)(GlobalSearch), {
  fragments: {
    currentUser: function currentUser() {
      return function () {
        return {
          children: [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, {
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'username',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'GlobalSearch_CurrentUserRelayQL',
          type: 'User'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactIntl = __webpack_require__(188);

var _recompose = __webpack_require__(959);

var _glamor = __webpack_require__(273);

var _ShopLink = __webpack_require__(993);

var _ShopLink2 = _interopRequireDefault(_ShopLink);

var _Link = __webpack_require__(960);

var _Link2 = _interopRequireDefault(_Link);

var _LogoutButton = __webpack_require__(977);

var _LogoutButton2 = _interopRequireDefault(_LogoutButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.searchLabel',
  description: 'Search Label',
  defaultMessage: 'Search'
});

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.profileLabel',
  description: 'Profile Label',
  defaultMessage: 'Profile'
});

var _ref4 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.menuLabel',
  description: 'Menu Label',
  defaultMessage: 'Menu'
});

var _ref5 = (0, _jsx3.default)(_LogoutButton2.default, {});

var UserMenu = function UserMenu(_ref) {
  var user = _ref.user,
      showSearch = _ref.showSearch,
      toggleSearch = _ref.toggleSearch,
      toggleFullPageNav = _ref.toggleFullPageNav,
      searchExpanded = _ref.searchExpanded;

  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      zIndex: '10'
    }),
    showSearch && !searchExpanded && _react2.default.createElement(
      'a',
      (0, _extends3.default)({}, (0, _glamor.css)({
        display: 'none',
        '@media (min-width: 701px)': {
          display: 'inline'
        },
        marginLeft: '1em',
        fontWeight: 'bold',
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      }), {
        href: 'javascript:;',
        onClick: toggleSearch }),
      _ref2
    ),
    _react2.default.createElement(
      _Link2.default,
      (0, _extends3.default)({ to: '/search'
      }, (0, _glamor.css)({
        display: 'inline',
        '@media (min-width: 701px)': {
          display: 'none'
        },
        marginLeft: '1em',
        fontWeight: 'bold',
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      })),
      'Search'
    ),
    _react2.default.createElement(
      _ShopLink2.default,
      (0, _extends3.default)({ user: user }, (0, _glamor.css)({
        display: 'none',
        '@media (min-width: 701px)': {
          display: 'inline'
        },
        marginLeft: '1em',
        fontWeight: 'bold',
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      })),
      _ref3
    ),
    _react2.default.createElement(
      'a',
      (0, _extends3.default)({}, (0, _glamor.css)({
        display: searchExpanded ? 'none' : 'block',
        '@media (min-width: 701px)': {
          display: 'none'
        },
        marginLeft: '1em',
        color: 'inherit',
        fontWeight: 'bold',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      }), {
        href: 'javascript:;',
        onClick: toggleFullPageNav }),
      _ref4
    ),
    _react2.default.createElement(
      'span',
      (0, _glamor.css)({
        display: 'none',
        '@media (min-width: 701px)': {
          display: 'inline'
        },
        marginLeft: '1em',
        fontWeight: 'bold',
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      }),
      _ref5
    )
  );
};

var enhance = (0, _recompose.compose)(_recompose.pure);

exports.default = _reactRelay2.default.createContainer(enhance(UserMenu), {
  fragments: {
    user: function user() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'UserMenu_UserRelayQL',
          type: 'User'
        };
      }(_ShopLink2.default.getFragment('user'));
    }
  }
});

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyRootStyles;

var _glamor = __webpack_require__(273);

function applyRootStyles() {
  (0, _glamor.insertRule)('html, body, div, span, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  abbr, address, cite, code,\n  del, dfn, em, img, ins, kbd, q, samp,\n  small, strong, sub, sup, var,\n  b, i,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section, summary,\n  time, mark, audio, video {\n    margin:0;\n    padding:0;\n    border:0;\n    outline:0;\n    font-size:100%;\n    vertical-align:baseline;\n    background:transparent;\n  }');

  (0, _glamor.insertRule)('body {\n    line-height:1;\n    padding-right:0px !important;\n    margin-right:0px !important;\n  }');

  (0, _glamor.insertRule)('article,aside,details,figcaption,figure,\n  footer,header,hgroup,menu,nav,section {\n    display:block;\n  }');

  (0, _glamor.insertRule)('nav ul {\n    list-style:none;\n  }');

  (0, _glamor.insertRule)('\n  @keyframes fadeIn {\n    0% { opacity: 0; }\n    50% { opacity: 0; }\n    100% { opacity: 100%; }\n  }\n\n  .fade-in {\n    animation: fadeIn 150ms ease-in;\n    animation-iteration-count: 1;\n  }');

  (0, _glamor.insertRule)('a {\n    margin:0;\n    padding:0;\n    font-size:100%;\n    vertical-align:baseline;\n    background:transparent;\n  }');

  (0, _glamor.insertRule)('table {\n    border-collapse:collapse;\n    border-spacing:0;\n  }');

  (0, _glamor.insertRule)('hr {\n    display:block;\n    height:1px;\n    border:0;\n    border-top:1px solid #cccccc;\n    margin:1em 0;\n    padding:0;\n  }');

  (0, _glamor.insertRule)('input, select {\n    vertical-align:middle;\n  }');

  (0, _glamor.insertRule)('html {\n    box-sizing: border-box;\n  }');

  (0, _glamor.insertRule)('*, *:before, *:after {\n    box-sizing: inherit;\n  }');

  (0, _glamor.insertRule)('html,\n  body {\n    margin: 0;\n    padding: 0;\n    font-family: \'Helvetica\', Arial, sans-serif;\n    font-size: 16px;\n    background: white;\n  }');

  (0, _glamor.insertRule)('input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 10000px white inset;\n  }');

  (0, _glamor.insertRule)('body.modal-open {\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n  }');

  (0, _glamor.insertRule)('@media (min-width: 701px) {\n    body.modal-open {\n      position: absolute;\n      overflow-y: scroll;\n    }\n  }');

  (0, _glamor.insertRule)('#nprogress {\n    pointer-events: none;\n  }');

  (0, _glamor.insertRule)('#nprogress .bar {\n    background: #f00;\n\n    position: fixed;\n    z-index: 1031;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 2px;\n  }');

  (0, _glamor.insertRule)('#nprogress .peg {\n    display: block;\n    position: absolute;\n    right: 0px;\n    width: 100px;\n    height: 100%;\n    opacity: 1.0;\n    transform: rotate(3deg) translate(0px, -4px);\n  }');
}

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function() {for(var aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,d){if(d.get||d.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[b]=d.value)},k="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,n=["String","prototype","includes"],ba=0;ba<n.length-1;ba++){var ca=n[ba];ca in k||(k[ca]={});k=k[ca]}
var da=n[n.length-1],ea=k[da],fa=ea?ea:function(a,b){if(null==this)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(a instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return-1!==(this+"").indexOf(a,b||0)};fa!=ea&&null!=fa&&aa(k,da,{configurable:!0,writable:!0,value:fa});
function ga(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var d=Object.prototype.toString.call(a);if("[object Window]"==d)return"object";if("[object Array]"==d||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==d||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ha(a,b,d){return a.call.apply(a.bind,arguments)}function ia(a,b,d){if(!a)throw Error();if(2<arguments.length){var c=Array.prototype.slice.call(arguments,2);return function(){var d=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(d,c);return a.apply(b,d)}}return function(){return a.apply(b,arguments)}}
function ja(a,b,d){ja=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ha:ia;return ja.apply(null,arguments)};function ka(a){return/^\s*$/.test(a)?!1:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,""))}function la(a){a=String(a);if(ka(a))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function p(a){var b=[];ma(new na,a,b);return b.join("")}function na(){}
function ma(a,b,d){if(null==b)d.push("null");else{if("object"==typeof b){if("array"==ga(b)){var c=b;b=c.length;d.push("[");for(var e="",f=0;f<b;f++)d.push(e),ma(a,c[f],d),e=",";d.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{d.push("{");e="";for(c in b)Object.prototype.hasOwnProperty.call(b,c)&&(f=b[c],"function"!=typeof f&&(d.push(e),oa(c,d),d.push(":"),ma(a,f,d),e=","));d.push("}");return}}switch(typeof b){case "string":oa(b,d);break;case "number":d.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":d.push(String(b));break;case "function":d.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var pa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},qa=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function oa(a,b){b.push('"',a.replace(qa,function(b){var a=pa[b];a||(a="\\u"+(b.charCodeAt(0)|65536).toString(16).substr(1),pa[b]=a);return a}),'"')};function r(a){a=String(a);try{return JSON.parse(a)}catch(b){}throw Error("Invalid JSON string: "+a);}function t(a){try{return"object"===typeof JSON&&"function"===typeof JSON.stringify?JSON.stringify(a):p(a)}catch(b){}throw Error("Could not stringify object");};function sa(){function a(){if(b.length)b[0](function(){b.shift();a()})}var b=[];return function(d){b.push(d);1===b.length&&a()}};function u(a,b,d){a=a.replace(/\$(\d)/g,function(a,d){return b[parseInt(d,10)-1]});d&&(a+="\n Failure Code:"+d);return a}function v(a){return{data:a.data||null,data_parsed:a.data_parsed||null,has_app:a.has_app||null,identity:a.identity||null,referring_identity:a.referring_identity||null,referring_link:a.referring_link||null}}
function ta(a){var b=/^\$journeys_\S+$/,d=a.data,c={};if(!d)return{};switch(typeof d){case "string":try{d=r(d)}catch(e){d=la(d)}break;case "object":break;default:d={}}Object.keys(d).forEach(function(a){b.test(a)&&(c[a]=d[a])});return c}function ua(){var a;a="_branch_view_id".replace(/[\[\]]/g,"\\$&");return(a=(new RegExp("[?&]"+a+"(=([^&#]*)|&|#|$)")).exec(String(window.location)))&&a[2]?decodeURIComponent(a[2].replace(/\+/g," ")):""}
function w(a){a.source="web-sdk";var b=a.data;switch(typeof b){case "string":try{b=r(b)}catch(d){b=la(b)}break;case "object":break;default:b={}}b.$canonical_url||(b.$canonical_url=String(window.location));b.$og_title||(b.$og_title=va("title"));b.$og_description||(b.$og_description=va("description"));b.$og_image_url||(b.$og_image_url=va("image"));b.$og_video||(b.$og_video=va("video"));"string"===typeof b.$desktop_url&&(b.$desktop_url=b.$desktop_url.replace(/#r:[a-z0-9-_]+$/i,"").replace(/([\?\&]_branch_match_id=\d+)/,
""));try{r(b)}catch(d){b=p(b)}a.data=b;return a}function y(a,b){a&&"object"===typeof a||(a={});if(!b||"object"!==typeof b)return a;for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);return a}function wa(){try{var a=window.location.hash.match(/r:([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}
function z(){var a=navigator.userAgent;return a.match(/android/i)?"android":a.match(/ipad/i)?"ipad":a.match(/i(os|p(hone|od))/i)?"ios":a.match(/\(BB[1-9][0-9]*\;/i)?"blackberry":a.match(/Windows Phone/i)?"windows_phone":a.match(/Kindle/i)||a.match(/Silk/i)||a.match(/KFTT/i)||a.match(/KFOT/i)||a.match(/KFJWA/i)||a.match(/KFJWI/i)||a.match(/KFSOWI/i)||a.match(/KFTHWA/i)||a.match(/KFTHWI/i)||a.match(/KFAPWA/i)||a.match(/KFAPWI/i)?"kindle":!1}
function xa(){try{var a=window.location.search.substring(1).match(/_branch_match_id=([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}function ya(a){return a.replace(/(\-\w)/g,function(b){return b[1].toUpperCase()})}
function za(a){var b="",d,c,e,f,h,l,g=0;a=a.replace(/\r\n/g,"\n");c="";for(e=0;e<a.length;e++)f=a.charCodeAt(e),128>f?c+=String.fromCharCode(f):(127<f&&2048>f?c+=String.fromCharCode(f>>6|192):(c+=String.fromCharCode(f>>12|224),c+=String.fromCharCode(f>>6&63|128)),c+=String.fromCharCode(f&63|128));for(a=c;g<a.length;)d=a.charCodeAt(g++),c=a.charCodeAt(g++),e=a.charCodeAt(g++),f=d>>2,d=(d&3)<<4|c>>4,h=(c&15)<<2|e>>6,l=e&63,isNaN(c)?l=h=64:isNaN(e)&&(l=64),b=b+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(f)+
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(d)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(h)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(l);return b}function Aa(a,b,d){"function"===typeof a.addEventListener?a.addEventListener(b,d,void 0):"function"===typeof a.attachEvent?a.attachEvent("on"+b,d):a["on"+b]=d}
function Ba(a){if(!a)return null;-1<a.indexOf("://")&&(a=a.split("://")[1]);return a.substring(a.indexOf("/")+1)}function Ca(a){if(!a)return null;-1<a.indexOf("://")?a=a.split("://")[1]:"/"===a.charAt(0)&&(a=a.slice(1));return a}function va(a){var b;a=String(a);b=b||null;(a=document.querySelector('meta[property="og:'+a+'"]'))&&a.content&&(b=a.content);return b}
function Da(){for(var a={},b=document.getElementsByTagName("meta"),d=0;d<b.length;d++)if((b[d].getAttribute("name")||b[d].getAttribute("property"))&&b[d].getAttribute("content")){var c=b[d].getAttribute("name"),e=b[d].getAttribute("property"),c=c||e;"al:ios:url"===c?a.$ios_deeplink_path=Ca(b[d].getAttribute("content")):"al:android:url"===c?a.$android_deeplink_path=Ca(b[d].getAttribute("content")):(c=c.split(":"),3===c.length&&"branch"===c[0]&&"deeplink"===c[1]&&(a[c[2]]=b[d].getAttribute("content")))}return a}
function Ea(){var a;try{a=(navigator.language||navigator.browserLanguage||"en").split(/[^a-z^A-Z0-9-]/).shift().toLowerCase()}catch(b){a="en"}return a}function Fa(a,b){var d=[];b.forEach(function(b){-1===a.indexOf(b)&&d.push(b)});return d}
var Ga=["purchase"],A={missingPurchaseEvent:"event name is either missing, of the wrong type or not valid. Please specify 'purchase' as the event name.",missingCommerceData:"commerce_data is either missing, of the wrong type or empty. Please ensure that commerce_data is constructed correctly.",invalidKeysForRoot:"Please remove the following keys from the root of commerce_data: ",invalidKeysForProducts:"Please remove the following keys from commerce_data.products: ",invalidProductListType:"commerce_data.products must be an array of objects",
invalidProductType:"Each product in the products list must be an object"};
function Ha(a){var b="sku name price quantity brand category variant".split(" "),d=Fa("common type transaction_id currency revenue revenue_in_usd exchange_rate shipping tax coupon affiliation persona products".split(" "),Object.keys(a));if(d.length)return A.invalidKeysForRoot+d.join(", ");var c=[],e;if(a.hasOwnProperty("products")){if(!Array.isArray(a.products))return A.invalidProductListType;a.products.forEach(function(a){"object"!==typeof a&&(e=A.invalidProductType);c=c.concat(Fa(b,Object.keys(a)))});
if(e)return e;if(c.length)return A.invalidKeysForProducts+c.join(", ")}return null}function Ia(a,b){if(!a||"string"!==typeof a||-1===Ga.indexOf(a.toLowerCase()))return A.missingPurchaseEvent;if(!b||"object"!==typeof b||!Object.keys(b).length)return A.missingCommerceData;var d=Ha(b);return d?d:null}function B(a){return"string"!==typeof a?null:a.replace(/</g,"&lt;").replace(/>/g,"&gt;")};function C(a,b){return function(d,c,e){if("number"===typeof e||e)if(0===b){if("object"!==typeof e)return u("API request $1, parameter $2 is not $3",[d,c,"an object"])}else if(3===b){if(!(e instanceof Array))return u("API request $1, parameter $2 is not $3",[d,c,"an array"])}else if(2===b){if("number"!==typeof e)return u("API request $1, parameter $2 is not $3",[d,c,"a number"])}else if(4===b){if("boolean"!==typeof e)return u("API request $1, parameter $2 is not $3",[d,c,"a boolean"])}else{if("string"!==
typeof e)return u("API request $1, parameter $2 is not $3",[d,c,"a string"]);if(1!==b&&!b.test(e))return u("API request $1, parameter $2 is not $3",[d,c,"in the proper format"])}else if(a)return u("API request $1 missing parameter $2",[d,c]);return!1}}var D=/^[0-9]{15,20}$/;function E(a){return y(a,{browser_fingerprint_id:C(!0,D),identity_id:C(!0,D),sdk:C(!0,1),session_id:C(!0,D)})}
var Ja={destination:"https://api.branch.io",endpoint:"/v1/open",method:"POST",a:{browser_fingerprint_id:C(!0,D),identity_id:C(!1,D),link_identifier:C(!1,1),sdk:C(!1,1),options:C(!1,0),initial_referrer:C(!1,1)}},Ka={destination:"https://app.link",endpoint:"/_r",method:"GET",U:!0,a:{sdk:C(!0,1),_t:C(!1,D),branch_key:C(!0,1)}},La={destination:"",endpoint:"",method:"GET",f:{link_url:C(!0,1)},a:{click:C(!0,1)}},Ma={destination:"https://bnc.lt",endpoint:"/c",method:"POST",f:{link_url:C(!0,1)},a:{sdk:C(!1,
1),phone:C(!0,1)}},Na={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",a:E({amount:C(!0,2),bucket:C(!1,1),calculation_type:C(!0,2),creation_source:C(!0,2),expiration:C(!1,1),location:C(!0,2),prefix:C(!1,1),type:C(!0,1)})},Oa={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",f:{code:C(!0,1)},a:E({})},Pa={destination:"https://api.branch.io",endpoint:"/v1/applycode",method:"POST",f:{code:C(!0,1)},a:E({})},Qa={destination:"https://api.branch.io",
endpoint:"/v1/logout",method:"POST",a:E({session_id:C(!0,D)})},Ra={destination:"https://api.branch.io",endpoint:"/v1/profile",method:"POST",a:E({identity_id:C(!0,D),identity:C(!0,1)})},Sa={destination:"https://api.branch.io",endpoint:"/v1/referrals",method:"GET",f:{identity_id:C(!0,D)},a:E({})},Ta={destination:"https://api.branch.io",endpoint:"/v1/credithistory",method:"GET",a:E({begin_after_id:C(!1,D),bucket:C(!1,1),direction:C(!1,2),length:C(!1,2),link_click_id:C(!1,D)})},Ua={destination:"https://api.branch.io",
endpoint:"/v1/credits",method:"GET",a:E({branch_key:C(!0,1),identity:C(!0,1)})},Va={destination:"https://api.branch.io",endpoint:"/v1/redeem",method:"POST",a:E({amount:C(!0,2),bucket:C(!0,1),identity_id:C(!0,D)})},Wa={destination:"https://api.branch.io",endpoint:"/v1/url",method:"POST",va:"obj",a:E({alias:C(!1,1),campaign:C(!1,1),channel:C(!1,1),data:C(!1,1),feature:C(!1,1),identity_id:C(!0,D),stage:C(!1,1),tags:C(!1,3),type:C(!1,2),source:C(!1,1)})},Xa={destination:"https://api.branch.io",endpoint:"/v1/deepview",
U:!0,method:"POST",a:E({campaign:C(!1,1),_t:C(!1,D),channel:C(!1,1),data:C(!0,1),feature:C(!1,1),link_click_id:C(!1,1),open_app:C(!1,4),append_deeplink_path:C(!1,4),stage:C(!1,1),tags:C(!1,3),deepview_type:C(!0,1),source:C(!0,1)})},Ya={destination:"https://api.branch.io",endpoint:"/v1/has-app",method:"GET",a:{browser_fingerprint_id:C(!0,D)}},Za={destination:"https://api.branch.io",endpoint:"/v1/event",method:"POST",a:E({event:C(!0,1),metadata:C(!0,0),initial_referrer:C(!1,1)})},$a={destination:"https://api.branch.io",
endpoint:"/v1/event",method:"POST",a:E({event:C(!0,1),metadata:C(!1,0),initial_referrer:C(!1,1),commerce_data:C(!0,0)})};function F(a){for(var b=0;b<a.length;b++){var d=this[a[b]],d="function"===typeof d?d():d;if(d.isEnabled())return d.o={},d}}function G(a){return"branch_session"===a||"branch_session_first"===a?a:"BRANCH_WEBSDK_KEY"+a}function ab(a){return"true"===a?!0:"false"===a?!1:a}
function bb(a){var b;try{b=a&&localStorage?localStorage:sessionStorage}catch(d){return{isEnabled:function(){return!1}}}return{getAll:function(){if("undefined"===typeof b)return null;var a=null,c;for(c in b)c.indexOf("BRANCH_WEBSDK_KEY")||(null===a&&(a={}),a[c.replace("BRANCH_WEBSDK_KEY","")]=ab(b.getItem(c)));return a},get:function(a,c){return ab(c&&localStorage?localStorage.getItem(G(a)):b.getItem(G(a)))},set:function(a,c,e){e&&localStorage?localStorage.setItem(G(a),c):b.setItem(G(a),c)},remove:function(a,
c){c&&localStorage?localStorage.removeItem(G(a)):b.removeItem(G(a))},clear:function(){Object.keys(b).forEach(function(a){a.indexOf("BRANCH_WEBSDK_KEY")||b.removeItem(a)})},isEnabled:function(){try{return b.setItem("test",""),b.removeItem("test"),!0}catch(d){return!1}}}}F.prototype.local=function(){return bb(!0)};F.prototype.session=function(){return bb(!1)};
function cb(a){return{getAll:function(){for(var a=document.cookie.split(";"),d={},c=0;c<a.length;c++){var e=a[c].replace(" ",""),e=e.substring(0,e.length);-1!==e.indexOf("BRANCH_WEBSDK_KEY")&&(e=e.split("="),d[e[0].replace("BRANCH_WEBSDK_KEY","")]=ab(e[1]))}return d},get:function(a){a=G(a)+"=";for(var b=document.cookie.split(";"),c=0;c<b.length;c++){var e=b[c],e=e.substring(1,e.length);if(!e.indexOf(a))return ab(e.substring(a.length,e.length))}return null},set:function(b,d){var c=G(b),e="";a&&(e=
new Date,e.setTime(e.getTime()+31536E6),e="; branch_expiration_date="+e.toGMTString()+"; expires="+e.toGMTString());document.cookie=c+"="+d+e+"; path=/"},remove:function(a){document.cookie=G(a)+"=; expires=; path=/"},clear:function(){function b(a){document.cookie=a.substring(0,a.indexOf("="))+"=;expires=-1;path=/"}for(var d=document.cookie.split(";"),c=0;c<d.length;c++){var e=d[c],e=e.substring(1,e.length);-1!==e.indexOf("BRANCH_WEBSDK_KEY")&&(a||-1!==e.indexOf("branch_expiration_date=")?a&&0<e.indexOf("branch_expiration_date=")&&
b(e):b(e))}},isEnabled:function(){return navigator.cookieEnabled}}}F.prototype.cookie=function(){return cb(!1)};F.prototype.permcookie=function(){return cb(!0)};F.prototype.pojo={getAll:function(){return this.o},get:function(a){return this.o[a]||null},set:function(a,b){this.o[a]=b},remove:function(a){delete this.o[a]},clear:function(){this.o={}},isEnabled:function(){return!0}};function H(a,b){try{return r(a.get(b?"branch_session_first":"branch_session",b))||null}catch(d){return null}}function db(a,b,d){a.set("branch_session",p(b));d&&a.set("branch_session_first",p(b),!0)}function eb(a,b){if(b){var d=H(a)||{},d=y(d,b);a.set("branch_session",p(d))}};function fb(){}fb.prototype.g=0;function gb(a,b,d){if("undefined"===typeof b)return"";var c=[];if(b instanceof Array){for(a=0;a<b.length;a++)c.push(encodeURIComponent(d)+"="+encodeURIComponent(b[a]));return c.join("&")}for(var e in b)b.hasOwnProperty(e)&&(b[e]instanceof Array||"object"===typeof b[e]?c.push(gb(a,b[e],d?d+"."+e:e)):c.push(encodeURIComponent(d?d+"."+e:e)+"="+encodeURIComponent(b[e])));return c.join("&")}
function hb(a,b,d){function c(a,c){"undefined"===typeof c&&(c={});if(a.branch_key&&g.test(a.branch_key))return c.branch_key=a.branch_key,c;if(a.app_id&&l.test(a.app_id))return c.app_id=a.app_id,c;throw Error(u("API request $1 missing parameter $2",[b.endpoint,"branch_key or app_id"]));}var e,f,h=b.destination+b.endpoint,l=/^[0-9]{15,20}$/,g=/key_(live|test)_[A-Za-z0-9]{32}/;if("/v1/has-app"===b.endpoint)try{b.f=c(d,b.f)}catch(q){return{error:q.message}}if("undefined"!==typeof b.f)for(e in b.f)if(b.f.hasOwnProperty(e)){if(f=
"function"===typeof b.f[e]?b.f[e](b.endpoint,e,d[e]):f)return{error:f};h+="/"+d[e]}var m={};if("undefined"!==typeof b.a)for(e in b.a)if(b.a.hasOwnProperty(e)){if(f=b.a[e](b.endpoint,e,d[e]))return{error:f};f=d[e];"undefined"!==typeof f&&""!==f&&null!==f&&(m[e]=f)}if("POST"===b.method||"/v1/credithistory"===b.endpoint)try{d=c(d,m)}catch(q){return{error:q.message}}"/v1/event"===b.endpoint&&(m.metadata=t(m.metadata||{}),m.hasOwnProperty("commerce_data")&&(m.commerce_data=t(m.commerce_data||{})));"/v1/open"===
b.endpoint&&(m.options=t(m.options||{}));return{data:gb(a,m,""),url:h.replace(/^\//,"")}}function ib(a,b,d){var c=document.createElement("script");c.type="text/javascript";c.async=!0;c.src=a;a=document.getElementsByTagName("head");!a||1>a.length?"function"===typeof b&&b():(a[0].appendChild(c),"function"===typeof b&&Aa(c,"error",b),"function"===typeof d&&Aa(c,"load",d))}var jb=0;
function kb(a,b,d,c,e){var f="branch_callback__"+a.g++;a=0<=b.indexOf("branch.io")?"&data=":"&post_data=";d="POST"===c?encodeURIComponent(za(p(d))):"";var h=window.setTimeout(function(){window[f]=function(){};e(Error("Request timed out"),null,504)},5E3);window[f]=function(a){window.clearTimeout(h);e(null,a)};ib(b+(0>b.indexOf("?")?"?":"")+(d?a+d:"")+(0<=b.indexOf("/c/")?"&click=1":"")+"&callback="+f,function(){e(Error("Request blocked by client, probably adblock"),null)},function(){try{"function"===
typeof this.remove?this.remove():this.parentNode.removeChild(this)}catch(l){}delete window[f]})}
function lb(a,b,d,c,e,f,h){var l=window.XMLHttpRequest?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP");l.ontimeout=function(){f(Error("Request timed out"),null,504)};l.onerror=function(a){f(Error(a.error||"Error in API: "+l.status),null,l.status)};l.onreadystatechange=function(){var a;if(4===l.readyState)if(200===l.status){if(h)a=l.responseText;else try{a=r(l.responseText)}catch(m){a={}}f(null,a,l.status)}else 402===l.status?f(Error("Not enough credits to redeem."),null,l.status):"4"!==
l.status.toString().substring(0,1)&&"5"!==l.status.toString().substring(0,1)||f(Error("Error in API: "+l.status),null,l.status)};try{l.open(c,b,!0),l.timeout=5E3,l.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),l.send(d)}catch(g){e.set("use_jsonp",!0),kb(a,b,d,c,f)}}
function mb(a,b,d,c,e){function f(){c.get("use_jsonp")||b.U?kb(a,g,d,b.method,h):lb(a,g,m,b.method,c,h)}function h(a,b,c){a&&0<q&&"5"===(c||"").toString().substring(0,1)?(q--,window.setTimeout(function(){f()},200)):e(a,b)}var l=hb(a,b,d);if(l.error)return e(Error(l.error));var g,m="";"GET"===b.method?g=l.url+"?"+l.data:(g=l.url,m=l.data);var q=2;f()};function J(a){a&&a.parentNode.removeChild(a)}function nb(a,b){a&&!a.className.match(new RegExp("(\\s|^)"+b+"(\\s|$)"))&&(a.className+=" "+b)}function ob(a){var b=document.body;b&&b.className.match(new RegExp("(\\s|^)"+a+"(\\s|$)"))&&(b.className=b.className.replace(new RegExp("(\\s|^)"+a+"(\\s|$)")," "))}function pb(a){var b=new Date;return b.setDate(b.getDate()+a)}
function qb(a){return document.body.currentStyle?document.body.currentStyle[ya(a)]:window.getComputedStyle(document.body).getPropertyValue(a)}
function rb(a){function b(a){function c(){return Math.max(document.documentElement.clientHeight,window.innerHeight||0)/100}function d(){return Math.max(document.documentElement.clientWidth,window.innerWidth||0)/100}if(!a)return 0;var f=a.replace(/[0-9,\.]/g,"");a=a.match(/\d+/g);var h=parseInt(0<a.length?a[0]:"0",10);return parseInt({px:function(a){return a},em:function(a){return document.body.currentStyle?a*b(document.body.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.body).fontSize)},
rem:function(a){return document.documentElement.currentStyle?a*b(document.documentElement.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.documentElement).fontSize)},vw:function(a){return a*d()},vh:function(a){return a*c()},vmin:function(a){return a*Math.min(c(),d())},vmax:function(a){return a*Math.max(c(),d())},"%":function(){return document.body.clientWidth/100*h}}[f](h),10)}return(b("76px")+b(a)).toString()+"px"}
function sb(a,b){var d=a.get("hideBanner",!0);if(b.ia&&navigator&&Number(navigator.doNotTrack))return!1;try{"string"===typeof d&&(d=r(d))}catch(e){d=!1}var d="number"===typeof d?new Date>=new Date(d):!d,c=b.F;"number"===typeof c&&(c=!1);return!document.getElementById("branch-banner")&&!document.getElementById("branch-banner-iframe")&&(d||c)&&(b.ka&&!z()||b.I&&"android"===z()||b.la&&"ipad"===z()||b.M&&"ios"===z()||b.J&&"blackberry"===z()||b.L&&"windows_phone"===z()||b.K&&"kindle"===z())};function tb(a,b){return"#branch-banner-iframe { position: "+("top"!==b||a?"fixed":"absolute")+"; }\n"}
function ub(a,b){var d=".branch-banner-is-active { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner { width:100%; z-index: 99999; font-family: Helvetica Neue, Sans-serif; -webkit-font-smoothing: antialiased; -webkit-user-select: none; -moz-user-select: none; user-select: none; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner .button{ border: 1px solid "+(a.buttonBorderColor||("dark"===a.theme?"transparent":"#ccc"))+"; background: "+
(a.buttonBackgroundColor||"#fff")+"; color: "+(a.buttonFontColor||"#000")+"; cursor: pointer; margin-top: 0px; font-size: 14px; display: inline-block; margin-left: 5px; font-weight: 400; text-decoration: none;  border-radius: 4px; padding: 6px 12px; transition: all .2s ease;}\n#branch-banner .button:hover {  border: 1px solid "+(a.buttonBorderColorHover||("dark"===a.theme?"transparent":"#BABABA"))+"; background: "+(a.buttonBackgroundColorHover||"#E0E0E0")+"; color: "+(a.buttonFontColorHover||"#000")+
";}\n#branch-banner .button:focus { outline: none; }\n#branch-banner * { margin-right: 4px; position: relative; line-height: 1.2em; }\n#branch-banner-close { font-weight: 400; cursor: pointer; float: left; z-index: 2;padding: 0 5px 0 5px; margin-right: 0; }\n#branch-banner .content { width:100%; overflow: hidden; height: 76px; background: rgba(255, 255, 255, 0.95); color: #333; "+("top"===a.position?"border-bottom":"border-top")+': 1px solid #ddd; }\n#branch-banner-close { color: #000; font-size: 24px; top: 14px; opacity: .5; transition: opacity .3s ease; }\n#branch-banner-close:hover { opacity: 1; }\n#branch-banner .title { font-size: 18px; font-weight:bold; color: #555; }\n#branch-banner .description { font-size: 12px; font-weight: normal; color: #777; max-height: 30px; overflow: hidden; }\n#branch-banner .icon { float: left; padding-bottom: 40px; margin-right: 10px; margin-left: 5px; }\n#branch-banner .icon img { width: 63px; height: 63px; margin-right: 0; }\n#branch-banner .reviews { font-size:13px; margin: 1px 0 3px 0; color: #777; }\n#branch-banner .reviews .star { display:inline-block; position: relative; margin-right:0; }\n#branch-banner .reviews .star span { display: inline-block; margin-right: 0; color: #555; position: absolute; top: 0; left: 0; }\n#branch-banner .reviews .review-count { font-size:10px; }\n#branch-banner .reviews .star .half { width: 50%; overflow: hidden; display: block; }\n#branch-banner .content .left { padding: 6px 5px 6px 5px; }\n#branch-banner .vertically-align-middle { top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); }\n#branch-banner .details > * { display: block; }\n#branch-banner .content .left { height: 63px; }\n#branch-banner .content .right { float: right; height: 63px; margin-bottom: 50px; padding-top: 22px; z-index: 1; }\n#branch-banner .right > div { float: left; }\n#branch-banner-action { top: 17px; }\n#branch-banner .content:after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 1px; background: rgba(0, 0, 0, 0.2); }\n#branch-banner .theme-dark.content { background: rgba(51, 51, 51, 0.95); }\n#branch-banner .theme-dark #branch-banner-close{ color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .details { text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .title { color: #fff; }\n#branch-banner .theme-dark .description { color: #fff; }\n#branch-banner .theme-dark .reviews { color: #888; }\n#branch-banner .theme-dark .reviews .star span{ color: #fff; }\n#branch-banner .theme-dark .reviews .review-count{ color: #fff; }\n',
c=z();"ios"!==c&&"ipad"!==c||!a.M?"android"===c&&a.I?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n#branch-banner #branch-banner-close,#branch-banner .theme-dark #branch-banner-close { height:17px; width: 17px; text-align: center; font-size: 15px; top: 24px;  border-radius:14px; border:0; line-height:14px; color:#b1b1b3; background:#efefef; padding: 0; opacity: 1; }\n#branch-banner .button { top: 0; text-decoration:none; border-bottom: 3px solid #A4C639; padding: 0 10px; height: 24px; line-height: 24px; text-align: center; color: #fff; margin-top: 2px;  font-weight: bold; background-color: #A4C639; border-radius: 5px; }\n#branch-banner .button:hover { border-bottom:3px solid #8c9c29; background-color: #c1d739; }\n":
"blackberry"===c&&a.J?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
"windows_phone"===c&&a.L?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
"kindle"===c&&a.K?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
(d+="#branch-banner { position: fixed; min-width: 600px; }\n#branch-sms-block * { vertical-align: bottom; font-size: 15px; }\n#branch-sms-block { display: inline-block; }\n#branch-banner input{ border: 1px solid #ccc;  font-weight: 400;  border-radius: 4px; height: 30px; padding: 5px 7px 4px; width: 145px; font-size: 14px;}\n#branch-banner input:focus { outline: none; }\n#branch-banner input.error { color: rgb(194, 0, 0); border-color: rgb(194, 0, 0); }\n#branch-banner .branch-icon-wrapper { width:25px; height: 25px; vertical-align: middle; display: inline-block; margin-top: -18px; }\n@keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n@-webkit-keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n#branch-spinner { -webkit-animation: branch-spinner 1s ease-in-out infinite; animation: branch-spinner 1s ease-in-out infinite; transition: all 0.7s ease-in-out; border:2px solid #ddd; border-bottom-color:#428bca; width:80%; height:80%; border-radius:50%; -webkit-font-smoothing: antialiased !important; }\n#branch-banner .theme-dark input { border-color: transparent; }\n",
d=window.ActiveXObject?d+"#branch-banner .checkmark { color: #428bca; font-size: 22px; }\n":d+"#branch-banner .checkmark { stroke: #428bca; stroke-dashoffset: 745.74853515625; stroke-dasharray: 745.74853515625; -webkit-animation: dash 2s ease-out forwards; animation: dash 2s ease-out forwards; }\n@-webkit-keyframes dash { 0% { stroke-dashoffset: 745.748535 15625; } 100% { stroke-dashoffset: 0; } }\n@keyframes dash { 0% { stroke-dashoffset: 745.74853515625; } 100% { stroke-dashoffset: 0; } }\n"):d+=
"#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n";
d+=a.$;a.w&&(d+="body { margin: 0; }\n",c=document.createElement("style"),c.type="text/css",c.id="branch-iframe-css",c.innerHTML="body { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: 76px; z-index: 99999; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n"+(z()?tb(a.ea,a.position):tb(a.aa,a.position)),(document.head||document.getElementsByTagName("head")[0]).appendChild(c));
c=document.createElement("style");c.type="text/css";c.id="branch-css";c.innerHTML=d;d=a.w?b.contentWindow.document:document;(d=d.head||d.getElementsByTagName("head")[0])&&"function"===typeof d.appendChild&&d.appendChild(c);"top"===a.position?b.style.top="-76px":"bottom"===a.position&&(b.style.bottom="-76px")};function vb(a,b){var d;if(a.s||a.G){if(a.s){d="";for(var c=0;5>c;c++)d+='<span class="star"><svg class="star" fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="star">\u2606</span></foreignObject></svg>',
a.s>c&&(d+=c+1>a.s&&a.s%1?'<span class="half"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 0h24v24H0V0z" id="a"/></defs><clipPath id="b"><use overflow="visible" xlink:href="#a"/></clipPath><path clip-path="url(#b)" d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg><foreignObject display="none"><span class="half">\u2605</span></foreignObject></span>':
'<span class="full"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="full">\u2605</span></foreignObject></svg> </span>'),d+="</span>";d='<span class="stars">'+d+"</span>"}else d="";d='<div class="reviews">'+d+(a.G?'<span class="review-count">'+
a.G+"</span>":"")+"</div>"}else d="";return'<div class="content'+(a.theme?" theme-"+a.theme:"")+'"><div class="right">'+b+'</div><div class="left">'+(a.ba?"":'<div id="branch-banner-close" class="branch-animation">&times;</div>')+'<div class="icon"><img src="'+a.icon+'"></div><div class="details vertically-align-middle"><div class="title">'+a.title+"</div>"+d+'<div class="description">'+a.description+"</div></div></div></div>"}
function wb(a,b){var d='<div id="branch-sms-form-container">'+(z()?'<a id="branch-mobile-action" class="button" href="#" target="_parent">'+((H(b)||{}).has_app?a.fa:a.ca)+"</a>":'<div class="branch-icon-wrapper" id="branch-loader-wrapper" style="opacity: 0;"><div id="branch-spinner"></div></div><div id="branch-sms-block"><form id="sms-form"><input type="phone" class="branch-animation" name="branch-sms-phone" id="branch-sms-phone" placeholder="'+a.ha+'"><button type="submit" id="branch-sms-send" class="branch-animation button">'+
a.ja+"</button></form></div>")+"</div>";if(a.w){var c=document.createElement("iframe");c.src="about:blank";c.style.overflow="hidden";c.scrolling="no";c.id="branch-banner-iframe";c.className="branch-animation";document.body.appendChild(c);var e=z(),d='<html><head></head><body class="'+("ios"===e||"ipad"===e?"branch-banner-ios":"android"===e?"branch-banner-android":"branch-banner-desktop")+'"><div id="branch-banner" class="branch-animation">'+vb(a,d)+"</body></html>";c.contentWindow.document.open();
c.contentWindow.document.write(d);c.contentWindow.document.close()}else c=document.createElement("div"),c.id="branch-banner",c.className="branch-animation",c.innerHTML=vb(a,d),document.body.appendChild(c);return d=c};function xb(a,b,d,c){function e(){h();g.style.background="#FFD4D4";l.className="error";setTimeout(function(){g.style.background="#FFFFFF";l.className=""},2E3)}function f(){x=a.createElement("div");x.className="branch-icon-wrapper";x.id="branch-checkmark";x.style="opacity: 0;";x.innerHTML=window.ActiveXObject?'<span class="checkmark">&#x2713;</span>':'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"><path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/></svg>';
q.appendChild(x);g.style.opacity="0";l.style.opacity="0";m.style.opacity="0";setTimeout(function(){x.style.opacity="1"},20);l.value=""}function h(){g.removeAttribute("disabled");l.removeAttribute("disabled");g.style.opacity="1";l.style.opacity="1";m.style.opacity="0"}var l=a.getElementById("branch-sms-phone"),g=a.getElementById("branch-sms-send"),m=a.getElementById("branch-loader-wrapper"),q=a.getElementById("branch-sms-form-container"),x;if(l){var I=l.value;/^\d{7,}$/.test(I.replace(/[\s()+\-\.]|ext/gi,
""))?(K(b,"willSendBannerSMS"),g.setAttribute("disabled",""),l.setAttribute("disabled",""),g.style.opacity=".4",l.style.opacity=".4",m.style.opacity="1",l.className="",b.sendSMS(I,c,d,function(a){a?(K(b,"sendBannerSMSError"),e()):(K(b,"didSendBannerSMS"),f(),setTimeout(function(){q.removeChild(x);h()},3E3))})):e()}}
function yb(a,b,d,c){function e(a,d){"function"===typeof a&&(d=a,a={});a=a||{};"top"===b.position?h.style.top="-76px":"bottom"===b.position&&(h.style.bottom="-76px");"number"===typeof b.F?c.set("hideBanner",pb(b.F),!0):c.set("hideBanner",!0,!0);a.T?("top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=x),ob("branch-banner-is-active"),J(h),J(document.getElementById("branch-css")),d()):(setTimeout(function(){J(h);J(document.getElementById("branch-css"));
d()},270),setTimeout(function(){"top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=x);ob("branch-banner-is-active")},20))}function f(){"top"===b.position?h.style.top="0":"bottom"===b.position&&(h.style.bottom="0");K(a,"didShowBanner")}if(!sb(c,b))return K(a,"willNotShowBanner"),null;K(a,"willShowBanner");var h=wb(b,c);ub(b,h);d.channel=d.channel||"app banner";var l=b.w?h.contentWindow.document:document;if(z()){b.open_app=b.ga;b.append_deeplink_path=
b.Z;b.make_new_link=b.da;b.deepview_type="banner";a.deepview(d,b);var g=l.getElementById("branch-mobile-action");g&&(g.onclick=function(b){b.preventDefault();a.deepviewCta()})}else l.getElementById("sms-form")?l.getElementById("sms-form").addEventListener("submit",function(c){c.preventDefault();xb(l,a,b,d)}):h.onload=function(){l=h.contentWindow.document;l.getElementById("sms-form")&&l.getElementById("sms-form").addEventListener("submit",function(c){c.preventDefault();xb(l,a,b,d)})};var g=qb("margin-top"),
m=document.body.style.marginTop,q=qb("margin-bottom"),x=document.body.style.marginBottom,I=l.getElementById("branch-banner-close");I&&(I.onclick=function(b){b.preventDefault();K(a,"willCloseBanner");e({},function(){K(a,"didCloseBanner")})});nb(document.body,"branch-banner-is-active");"top"===b.position?document.body.style.marginTop=rb(g):"bottom"===b.position&&(document.body.style.marginBottom=rb(q));b.T?f():setTimeout(f,20);return e};var L,M="top",N="absolute",O="76px",P=!1,zb=!1,Q=[],Ab=window.innerHeight,Bb=window.innerWidth;window.innerHeight<window.innerWidth&&(Ab=window.innerWidth,Bb=window.innerHeight);var Cb=0,Db=0,Eb=/<script type="application\/json">((.|\s)*?)<\/script>/,Fb=/<script type="text\/javascript">((.|\s)*?)<\/script>/,Gb=/<style type="text\/css" id="branch-css">((.|\s)*?)<\/style>/,Hb=/#branch-banner-spacer {((.|\s)*?)}/,Ib=/margin-bottom: (.*?);/,R=null,Jb=null,Kb=!1,S=!1,Lb=!1,T=!1,Mb=!1,Nb="",U=[];
function Ob(a){if(a=a.match(Eb))return r(a[1])}
function Pb(){var a=document.createElement("style");a.type="text/css";a.id="branch-iframe-css";var b="";Cb=qb("margin-top");var d=+Cb.slice(0,-2);Db=qb("margin-bottom");var c=+Db.slice(0,-2),e=+O.slice(0,-2);"top"===M?b="margin-top: "+(+e+d)+"px":"bottom"===M&&(b="margin-bottom: "+(+e+c)+"px");0<Q.length&&Q.forEach(function(a){var b,c=window.getComputedStyle(a);c&&(b=P&&"fixed"===c.getPropertyValue("position"));b||(a.style.marginTop=O)});"top"===Nb&&Nb!==M&&Mb&&U&&0<U.length&&U.forEach(function(a){a.style.marginTop=
0});Mb=!1;Nb="";U=[];T=!1;document.body.style.transition="";d="-webkit-transition: all 0.375s ease; transition: all 00.375s ease; ";c="-webkit-transition: all 0.25s ease; transition: all 00.25s ease;";Lb&&(c=d="");a.innerHTML="body { "+d+b+"; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: "+O+"; z-index: 99999; "+c+" }\n#branch-banner-iframe { position: "+N+"; }\n@media only screen and (orientation: landscape) { body { "+
("top"===M?"margin-top: ":"margin-bottom: ")+(P?Bb+"px":O)+"; }\n#branch-banner-iframe { height: "+(P?Bb+"px":O)+"; }";document.head.appendChild(a)}function Qb(a){nb(document.body,"branch-banner-is-active");P&&"fixed"===N&&nb(document.body,"branch-banner-no-scroll");setTimeout(function(){"top"===M?a.style.top="0":"bottom"===M&&(a.style.bottom="0");K(R,"didShowJourney",{banner_id:L});Kb=!0},20)}
function Rb(a){var b=7;if(a=a.match(Eb))a=r(a[1])||{},"number"===typeof a.dismissPeriod&&(b=a.dismissPeriod);return-1===b?!0:pb(b)}
function Sb(a,b,d,c,e){Jb=c;if(d&&c){var f=c.contentWindow.document;Array.prototype.forEach.call(f.querySelectorAll("#branch-mobile-action"),function(a){a.addEventListener("click",function(){K(R,"didClickJourneyCTA",{banner_id:L});T=!0;d();Tb(c)})});var h=f.querySelectorAll(".branch-banner-continue");Array.prototype.forEach.call(h,function(d){d.addEventListener("click",function(){K(R,"didClickJourneyContinue",{banner_id:L});T=!0;Tb(c);b.set("hideBanner"+a.id,e,!0)})});h=f.querySelectorAll(".branch-banner-close");
Array.prototype.forEach.call(h,function(d){d.addEventListener("click",function(){K(R,"didClickJourneyClose",{banner_id:L});T=!0;Tb(c);b.set("hideBanner"+a.id,e,!0)})})}}
function Tb(a){Lb&&!S&&(document.body.style.transition="all 00.375s ease",document.getElementById("branch-banner-iframe").style.transition="all 00.25s ease");"top"===M?a.style.top="-"+O:"bottom"===M&&(a.style.bottom="-"+O);K(R,"willCloseJourney",{banner_id:L});setTimeout(function(){J(a);J(document.getElementById("branch-css"));J(document.getElementById("branch-iframe-css"));(!S||T)&&Q&&0<Q.length?Q.forEach(function(a){a.style.marginTop=0}):(Mb=S,Nb=M,U=Q);"top"===M?document.body.style.marginTop=Cb:
"bottom"===M&&(document.body.style.marginBottom=Db);ob("branch-banner-is-active");ob("branch-banner-no-scroll");K(R,"didCloseJourney",{banner_id:L});Kb=!1},S?0:270)};function Ub(a,b){K(R,"willShowJourney",{banner_id:L});var d=b?"OPEN":"GET",c=a,e=Ob(c);e&&e.bannerHeight&&e.position&&e.sticky?(O=e.bannerHeight,M=e.position,N=e.sticky):(c=c.match(Hb))?(M="top",(c=c[1].match(Ib))&&(O=c[1]),N="absolute"):(M="bottom",N="fixed");if(-1!==O.indexOf("vh")||-1!==O.indexOf("%"))c=O.indexOf("vh")?O.slice(0,-2):O.slice(0,-1),O=c/100*Ab+"px",100>c?zb=!0:P=!0;if(c=Ob(a)){var f;b&&c&&c.ctaText&&c.ctaText.has_app?f=c.ctaText.has_app:c&&c.ctaText&&c.ctaText.no_app&&(f=c.ctaText.no_app);
d=f;Q=[];if(c&&c.injectorSelector&&(f=document.querySelectorAll(c.injectorSelector)))for(c=0;c<f.length;c++)Q.push(f[c].parentElement)}f=(f=a.match(Gb))?f[1]:void 0;if(c=a.match(Fb))e=document.createElement("script"),e.innerHTML=c[1],document.body.appendChild(e);var c=a,e=c.match(Eb),h=c.match(Fb),l=c.match(Gb);e&&(c=c.replace(Eb,""));h&&(c=c.replace(Fb,""));l&&(c=c.replace(Gb,""));a=c;c=document.createElement("iframe");c.src="about:blank";c.style.overflow="hidden";c.scrolling="no";c.id="branch-banner-iframe";
c.className="branch-animation";document.body.appendChild(c);e=z();e='<html><head></head><body class="'+("ios"===e||"ipad"===e?"branch-banner-ios":"android"===e?"branch-banner-android":"branch-banner-desktop")+'">'+a+"</body></html>";c.contentWindow.document.open();c.contentWindow.document.write(e);c.contentWindow.document.close();Pb();e=document.createElement("style");e.type="text/css";e.id="branch-css";e.innerHTML=f;f=c.contentWindow.document;f.head.appendChild(e);if(zb||P){var g=f.getElementsByClassName("branch-banner-content")[0];
g&&(g.style.height=O)}"top"===M?c.style.top="-"+O:"bottom"===M&&(c.style.bottom="-"+O);try{var g=f.getElementsByClassName("branch-banner-content")[0],m=window.getComputedStyle(g).getPropertyValue("background-color").split(", ");m[3]&&!parseFloat(m[3])&&(c.style.boxShadow="none")}catch(q){}c.contentWindow.document.getElementById("branch-mobile-action").innerHTML=d;Qb(c);return c}
function Vb(a,b,d,c,e,f,h){if(!(document.getElementById("branch-banner")||document.getElementById("branch-banner-iframe")||document.getElementById("branch-banner-container"))){R=h;var l=null,g=null;d=d||{};d.feature="journeys";d=w(d);(h=document.getElementById("branch-iframe-css"))&&h.parentElement.removeChild(h);var m=document.createElement("div");m.id="branch-banner";document.body.insertBefore(m,null);nb(m,"branch-banner-is-active");if(b.html)Ub(b.html,e);else if(b.url){var q="branch_view_callback__"+
jb++;d=encodeURIComponent(za(p(d)));h=b.url+"&callback="+q;h+="&_lan="+(R.ma||Ea());lb(a,h+("&data="+d),{},"GET",{},function(a,d){var h=!1;if(!a&&d){var ra=f?0:Rb(d),x=window.setTimeout(function(){window[q]=function(){}},5E3);window[q]=function(a){window.clearTimeout(x);h||(g=a,Sb(b,c,g,l,ra))};l=Ub(d,e);if(null===l){h=!0;return}Sb(b,c,g,l,ra)}document.body.removeChild(m)},!0)}}}
function Wb(a,b){var d=b.b.get("hideBanner"+a.id,!0);if(!0===d||d>Date.now())return!0;b.b.remove("hideBanner"+a.id,!0);return!1}
function Xb(a,b,d,c,e){e.u=!!d.branch_view_enabled;e.b.set("branch_view_enabled",e.u);var f=null,h=null,l=null,g=null,m=null,q=!1;c&&(f=c.branch_view_id||null,h=c.no_journeys||null,e.ma=c.user_language||Ea(),Lb=c.disable_entry_animation||!1,S=c.disable_exit_animation||!1);(f=f||ua()||null)&&z()&&(q=!0,g={id:f,ua:-1,url:"https://api.branch.io/v1/branchview/"+a+"/"+f+"?_a=audience_rule_id&_t="+b.D});!g&&d.hasOwnProperty("branch_view_data")&&(g=d.branch_view_data,l=Wb(g,e));!g||l||h?K(e,"willNotShowJourney"):
(L=g.id,e.renderQueue(function(){var a=e.A||{};a.data||(a.data={});a.data=y(Da(),a.data);a.data=y(ta(H(e.b)||{}),a.data);m=a;Vb(e.N,g,m,e.b,b.has_app,q,e)}))};var V={androidAppIndexingTagsPresent:!1,iosAppIndexingTagsPresent:!1,androidDetailsComplete:!1,iosDetailsComplete:!1},W={};function Yb(a){var b;"android"===a&&V.androidDetailsComplete&&(b="android-app://"+W.androidPackageName+"/"+W.androidURL,b=Zb(b),$b(b));"ios"===a&&V.iosDetailsComplete&&(b="ios-app://"+W.iosAppId+"/"+W.iosURL,b=Zb(b),$b(b))}
function Zb(a){var b={"~channel":"Firebase App Indexing","~feature":"Auto App Indexing",$canonical_url:String(window.location)};if("object"===typeof W.data)for(var d in W.data)W.data.hasOwnProperty(d)&&!b.hasOwnProperty(d)&&(b[d]=W.data[d]);return a+(-1<a.indexOf("?")?"&":"?")+"link_click_id=a-"+btoa(t(b))}function $b(a){var b=document.createElement("link");b.setAttribute("rel","alternate");b.setAttribute("href",a);document.head.appendChild(b)}
function ac(a){"android"===a&&"string"===typeof W.androidPackageName&&"string"===typeof W.androidURL&&(V.androidDetailsComplete=!0,Yb("android"));"ios"===a&&"string"===typeof W.iosAppId&&"string"===typeof W.iosURL&&(V.iosDetailsComplete=!0,Yb("ios"))}
function bc(a){for(var b=document.getElementsByTagName("meta"),d=0;d<b.length;d++){var c=b[d];"ios"===a&&"al:ios:app_store_id"===c.getAttribute("property")&&(W.iosAppId=c.getAttribute("content"));"ios"===a&&"al:ios:url"===c.getAttribute("property")&&(W.iosURL=c.getAttribute("content").replace("://","/"));"android"===a&&"al:android:package"===c.getAttribute("property")&&(W.androidPackageName=c.getAttribute("content"));"android"===a&&"al:android:url"===c.getAttribute("property")&&(W.androidURL=c.getAttribute("content").replace("://",
"/"))}ac(a)};var cc;
function X(a,b,d){return function(){var c=this,e,f,h=arguments[arguments.length-1];a&&"function"===typeof h?(e=Array.prototype.slice.call(arguments,0,arguments.length-1)||[],f=h):(f=function(){},e=Array.prototype.slice.call(arguments));c.X(function(l){function g(b,c){try{if(b&&!a)throw b;1===a?f(b):2===a&&f(b,c)}finally{l()}}if(!d){if(1===c.i)return g(Error(u("Branch SDK initialization pending and a Branch method was called outside of the queue order")),null);if(2===c.i)return g(Error(u("Branch SDK initialization failed, so further methods cannot be called",c.j,
c.m)),null);if(0===c.i||!c.i)return g(Error(u("Branch SDK not initialized")),null)}e.unshift(g);b.apply(c,e)})}}function Y(){if(!(this instanceof Y))return cc||(cc=new Y),cc;this.X=sa();this.b=new F(["session","cookie","pojo"]);this.N=new fb;this.g=[];this.P="web2.24.0";this.j=this.i=0;this.m=null}
Y.prototype.c=function(a,b,d){this.O&&(b.app_id=this.O);this.h&&(b.branch_key=this.h);(a.a&&a.a.session_id||a.f&&a.f.session_id)&&this.H&&(b.session_id=this.H);(a.a&&a.a.identity_id||a.f&&a.f.identity_id)&&this.v&&(b.identity_id=this.v);(a.a&&a.a.link_click_id||a.f&&a.f.link_click_id)&&this.V&&(b.link_click_id=this.V);(a.a&&a.a.sdk||a.f&&a.f.sdk)&&this.P&&(b.sdk=this.P);(a.a&&a.a.browser_fingerprint_id||a.f&&a.f.browser_fingerprint_id)&&this.D&&(b.browser_fingerprint_id=this.D);return mb(this.N,a,
b,this.b,function(a,b){d(a,b)})};function dc(a){var b=H(a.b);return(b=b&&b.referring_link)?b:(a=a.b.get("click_id"))?"https://bnc.lt/c/"+a:null}function K(a,b,d){for(var c=0;c<a.g.length;c++)a.g[c].event&&a.g[c].event!==b||a.g[c].listener(b,d)}
Y.prototype.init=X(2,function(a,b,d){function c(){var a,b;"undefined"!==typeof document.hidden?(a="hidden",b="visibilitychange"):"undefined"!==typeof document.mozHidden?(a="mozHidden",b="mozvisibilitychange"):"undefined"!==typeof document.msHidden?(a="msHidden",b="msvisibilitychange"):"undefined"!==typeof document.webkitHidden&&(a="webkitHidden",b="webkitvisibilitychange");b&&document.addEventListener(b,function(){document[a]||(h(null,null),"function"===typeof g.C&&g.C())},!1)}function e(c,e){e&&
(e=l(e),db(g.b,e,x),g.i=3,e.data_parsed=e.data?r(e.data):null);if(c)return g.i=2,g.j||(g.j=1,g.m=c.message),a(c,e&&v(e));g.c(Za,{event:"pageview",metadata:{url:String(window.location),user_agent:navigator.userAgent,language:navigator.language,page_has_microdata:f(),screen_width:screen.width||-1,screen_height:screen.height||-1},initial_referrer:document.referrer},function(c,f){c||"object"!==typeof f||Xb(b,e,f,d,g);try{a(c,e&&v(e))}catch(ic){}finally{g.renderFinalize()}})}function f(){var a=!1;try{a=
!!(document.querySelectorAll('*[itemtype^="http://schema.org"]')||[]).length}catch(ra){a=!1}return a}function h(a,b){var c={sdk:"2.24.0",branch_key:g.h},d=a||H(g.b)||{},e=H(g.b,!0)||{};e.browser_fingerprint_id&&(c._t=e.browser_fingerprint_id);g.c(Ka,c,function(a,b){a&&(g.j=3,g.m=a.message);b&&(d.browser_fingerprint_id=b)});g.c(Ya,{browser_fingerprint_id:d.browser_fingerprint_id},function(a,c){a&&(g.j=4,g.m=a.message);a||!c||d.has_app||(d.has_app=!0,eb(g.b,d),K(g,"didDownloadApp"));b&&b(null,d)})}
function l(a){a.link_click_id&&(g.V=a.link_click_id.toString());a.session_id&&(g.H=a.session_id.toString());a.identity_id&&(g.v=a.identity_id.toString());a.link&&(g.W=a.link);if(a.referring_link){var b=a.referring_link;a.referring_link=b?"http"!==b.substring(0,4)?"https://bnc.lt"+b:b:null}!a.click_id&&a.referring_link&&(b=a.referring_link,a.click_id=b?b.substring(b.lastIndexOf("/")+1,b.length):null);g.D=a.browser_fingerprint_id;return a}var g=this;g.i=1;-1<b.indexOf("key_")?g.h=b:g.O=b;d=d&&"function"===
typeof d?{}:d;var m=H(g.b),q=xa()||wa(),x=!m||!m.identity_id;g.u=!!g.b.get("branch_view_enabled");if(m&&m.session_id&&!q)c(),h(m,e);else{var m={sdk:"2.24.0",branch_key:g.h},I=H(g.b,!0)||{};I.browser_fingerprint_id&&(m._t=I.browser_fingerprint_id);g.c(Ka,m,function(a,b){if(a)return g.j=3,g.m=a.message,e(a,null);g.c(Ja,{link_identifier:q,browser_fingerprint_id:b,options:d,initial_referrer:document.referrer},function(a,b){a&&(g.j=2,g.m=a.message);a||"object"!==typeof b||(g.u=!!b.branch_view_enabled,
g.b.set("branch_view_enabled",g.u),q&&(b.click_id=q));c();e(a,b)})})}},!0);Y.prototype.renderQueue=X(0,function(a,b){this.Y?b():(this.l=this.l||[],this.l.push(b));a(null,null)});Y.prototype.renderFinalize=X(2,function(a){this.l&&0<this.l.length&&(this.l.forEach(function(a){a.call(this)}),delete this.l);this.Y=!0;a(null,null)});Y.prototype.data=X(2,function(a){var b=v(H(this.b));b.referring_link=dc(this);a(null,b)});Y.prototype.first=X(2,function(a){a(null,v(H(this.b,!0)))});
Y.prototype.setIdentity=X(2,function(a,b){var d=this;this.c(Ra,{identity:b},function(c,e){c&&a(c);e=e||{};d.v=e.identity_id?e.identity_id.toString():null;d.W=e.link;d.S=b;e.referring_data_parsed=e.referring_data?r(e.referring_data):null;eb(d.b,e);a(null,e)})});
Y.prototype.logout=X(1,function(a){var b=this;this.c(Qa,{},function(d,c){d&&a(d);c=c||{};c={data_parsed:null,data:null,referring_link:null,click_id:null,link_click_id:null,identity:null,session_id:c.session_id,identity_id:c.identity_id,link:c.link,device_fingerprint_id:b.ta||null};b.W=c.link;b.H=c.session_id;b.v=c.identity_id;b.S=c.identity;eb(b.b,c);a(null)})});
Y.prototype.track=X(1,function(a,b,d,c){var e=this;d=d||{};c=c||{};e.c(Za,{event:b,metadata:y({url:document.URL,user_agent:navigator.userAgent,language:navigator.language},d),initial_referrer:document.referrer},function(d,h){d||"object"!==typeof h||"pageview"!==b||Xb(e.h,H(e.b),h,c,e);"function"===typeof a&&a.apply(this,arguments)})});Y.prototype.link=X(2,function(a,b){this.c(Wa,w(b),function(b,c){a(b,c&&c.url)})});
Y.prototype.sendSMS=X(1,function(a,b,d,c){function e(c){f.c(Ma,{link_url:c,phone:b},function(b){a(b||null)})}var f=this;if("function"===typeof c)c={};else if("undefined"===typeof c||null===c)c={};c.make_new_link=c.make_new_link||!1;d.channel&&"app banner"!==d.channel||(d.channel="sms");var h=dc(f);h&&!c.make_new_link?e(h.substring(h.lastIndexOf("/")+1,h.length)):f.c(Wa,w(d),function(b,c){if(b)return a(b);var d=c.url;/(bnc.lt\/|app\.link\/)/.test(d)||(d="https://bnc.lt/"+Ba(d));f.c(La,{link_url:d,
click:"click"},function(b,c){if(b)return a(b);e(c.click_id)})})});
Y.prototype.deepview=X(1,function(a,b,d){var c=this;d||(d={});d.deepview_type="undefined"===typeof d.deepview_type?"deepview":"banner";b.data=y(Da(),b.data);var e="https://bnc.lt/a/"+c.h,f=!0,h;for(h in b)b.hasOwnProperty(h)&&"data"!==h&&(f?(e+="?",f=!1):e+="&",e+=encodeURIComponent(h)+"="+encodeURIComponent(b[h]));b=w(b);if(d.open_app||null===d.open_app||"undefined"===typeof d.open_app)b.open_app=!0;b.append_deeplink_path=!!d.append_deeplink_path;b.deepview_type=d.deepview_type;(f=dc(c))&&!d.make_new_link&&
(b.link_click_id=f.substring(f.lastIndexOf("/")+1,f.length));b.banner_options=d;c.C=ja(this.c,c,Xa,b,function(b,d){if(b)return c.B=function(){window.location=e},a(b);"function"===typeof d&&(c.B=d);a(null)});c.C()});Y.prototype.deepviewCta=X(1,function(a){if("undefined"===typeof this.B)throw Error("Cannot call Deepview CTA, please call branch.deepview() first.");window.event&&(window.event.preventDefault?window.event.preventDefault():window.event.returnValue=!1);K(this,"didDeepviewCTA");this.B();a()});
Y.prototype.referrals=X(2,function(a){this.c(Sa,{},a)});Y.prototype.getCode=X(2,function(a,b){b.type="credit";b.creation_source=b.creation_source||2;this.c(Na,b,a)});Y.prototype.validateCode=X(1,function(a,b){this.c(Oa,{code:b},a)});Y.prototype.applyCode=X(1,function(a,b){this.c(Pa,{code:b},a)});Y.prototype.credits=X(2,function(a){this.c(Ua,{branch_key:this.h,identity:this.S},a)});Y.prototype.creditHistory=X(2,function(a,b){this.c(Ta,b||{},a)});
Y.prototype.redeem=X(1,function(a,b,d){this.c(Va,{amount:b,bucket:d},function(b){a(b||null)})});Y.prototype.addListener=function(a,b){"function"===typeof a&&void 0===b&&(b=a);b&&this.g.push({listener:b,event:a||null})};Y.prototype.removeListener=function(a){a&&(this.g=this.g.filter(function(b){if(b.listener!==a)return b}))};function ec(a,b,d){d=d||{};try{a.A=r(t(d))}finally{a.A=a.A||{}}b()}Y.prototype.setBranchViewData=X(1,function(a,b){ec.call(null,this,a,b)});
Y.prototype.closeJourney=X(1,function(a){var b=this;b.renderQueue(function(){if(Jb&&Kb)K(b,"didCallJourneyClose",{banner_id:L}),Tb(Jb);else return a("Journey already dismissed.")});a()});
Y.prototype.banner=X(1,function(a,b,d){d=d||{};ec.call(null,this,function(){},d);"undefined"===typeof b.showAgain&&"undefined"!==typeof b.forgetHide&&(b.showAgain=b.forgetHide);var c={icon:B(b.icon)||"",title:B(b.title)||"",description:B(b.description)||"",G:"number"===typeof b.reviewCount&&0<b.reviewCount?Math.floor(b.reviewCount):null,s:"number"===typeof b.rating&&5>=b.rating&&0<b.rating?Math.round(2*b.rating)/2:null,fa:B(b.openAppButtonText)||"View in app",ca:B(b.downloadAppButtonText)||"Download App",
ja:B(b.sendLinkText)||"Send Link",ha:B(b.phonePreviewText)||"(999) 999-9999",w:"undefined"===typeof b.iframe?!0:b.iframe,M:"undefined"===typeof b.showiOS?!0:b.showiOS,la:"undefined"===typeof b.showiPad?!0:b.showiPad,I:"undefined"===typeof b.showAndroid?!0:b.showAndroid,J:"undefined"===typeof b.showBlackberry?!0:b.showBlackberry,L:"undefined"===typeof b.showWindowsPhone?!0:b.showWindowsPhone,K:"undefined"===typeof b.showKindle?!0:b.showKindle,ka:"undefined"===typeof b.showDesktop?!0:b.showDesktop,
ba:!!b.disableHide,F:"number"===typeof b.forgetHide?b.forgetHide:!!b.forgetHide,ia:"undefined"===typeof b.respectDNT?!1:b.respectDNT,position:b.position||"top",$:b.customCSS||"",ea:"undefined"===typeof b.mobileSticky?!1:b.mobileSticky,aa:"undefined"===typeof b.desktopSticky?!0:b.desktopSticky,pa:b.buttonBorderColor||"",na:b.buttonBackgroundColor||"",ra:b.buttonFontColor||"",qa:b.buttonBorderColorHover||"",oa:b.buttonBackgroundColorHover||"",sa:b.buttonFontColorHover||"",da:!!b.make_new_link,ga:!!b.open_app,
T:!!b.immediate,Z:!!b.append_deeplink_path};"undefined"!==typeof b.showMobile&&(c.M=b.showMobile,c.I=b.showMobile,c.J=b.showMobile,c.L=b.showMobile,c.K=b.showMobile);d.data=y(Da(),d.data);var e=this;e.renderQueue(function(){e.R=yb(e,c,d,e.b)});a()});Y.prototype.closeBanner=X(0,function(a){var b=this;b.renderQueue(function(){b.R&&(K(b,"willCloseBanner"),b.R(function(){K(b,"didCloseBanner")}))});a()});
Y.prototype.autoAppIndex=X(1,function(a,b){b=b||{};var d=document.getElementsByTagName("link"),c=d.length;if(c)for(var e=0;e<c;e++){var f=d[e],h=f.href;h&&(h.includes("ios-app")&&(V.iosAppIndexingTagsPresent=!0,f.setAttribute("href",Zb(h))),h.includes("android-app")&&(V.androidAppIndexingTagsPresent=!0,f.setAttribute("href",Zb(h))))}W=b;V.androidAppIndexingTagsPresent||(ac("android"),V.androidDetailsComplete||bc("android"));V.iosAppIndexingTagsPresent||(ac("ios"),V.iosDetailsComplete||bc("ios"));
V.iosDetailsComplete||V.androidDetailsComplete?a(null):a("Firebase App Indexing tags were not added to your webpage. Please check your configuration.")});Y.prototype.trackCommerceEvent=X(1,function(a,b,d,c){var e=this;e.renderQueue(function(){var f=Ia(b,d);if(f)return a(Error(f));e.c($a,{event:b,metadata:y({url:document.URL,user_agent:navigator.userAgent,language:navigator.language},c||{}),initial_referrer:document.referrer,commerce_data:d},function(b){a(b||null)})});a()});var Z=new Y;if(window.branch&&window.branch._q)for(var fc=window.branch._q,gc=0;gc<fc.length;gc++){var hc=fc[gc];Z[hc[0]].apply(Z,hc[1])} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports&&(module.exports=Z);window&&(window.branch=Z);})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(191),
    arrayMap = __webpack_require__(988),
    isArray = __webpack_require__(190),
    isSymbol = __webpack_require__(971);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(979);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos));
            val = options.decoder(part.slice(pos + 1));
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObjectRecursive(chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index) &&
            root !== cleanRoot &&
            String(index) === cleanRoot &&
            index >= 0 &&
            (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = parseObject(chain, val, options);
        }
    }

    return obj;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts || {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(979);
var formats = __webpack_require__(978);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
            return [formatter(keyValue) + '=' + formatter(encoder(obj))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts || {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats.default;
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    return keys.join(delimiter);
};


/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createBroadcast = function createBroadcast(initialValue) {
  var listeners = [];
  var currentValue = initialValue;

  return {
    publish: function publish(value) {
      currentValue = value;
      listeners.forEach(function (listener) {
        return listener(currentValue);
      });
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);

      // Publish to this subscriber once immediately.
      listener(currentValue);

      return function () {
        return listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    }
  };
};

/**
 * A <Broadcast> provides a generic way for descendants to "subscribe"
 * to some value that changes over time, bypassing any intermediate
 * shouldComponentUpdate's in the hierarchy. It puts all subscription
 * functions on context.broadcasts, keyed by "channel".
 *
 * To use it, a subscriber must opt-in to context.broadcasts. See the
 * <Subscriber> component for a reference implementation.
 */

var Broadcast = function (_React$Component) {
  _inherits(Broadcast, _React$Component);

  function Broadcast() {
    var _temp, _this, _ret;

    _classCallCheck(this, Broadcast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Broadcast.prototype.getBroadcastsContext = function getBroadcastsContext() {
    var _extends2;

    var channel = this.props.channel;
    var broadcasts = this.context.broadcasts;


    return _extends({}, broadcasts, (_extends2 = {}, _extends2[channel] = this.broadcast.subscribe, _extends2));
  };

  Broadcast.prototype.getChildContext = function getChildContext() {
    return {
      broadcasts: this.getBroadcastsContext()
    };
  };

  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    !(this.props.channel === nextProps.channel) ?  false ? (0, _invariant2.default)(false, 'You cannot change <Broadcast channel>') : (0, _invariant2.default)(false) : void 0;

    if (this.props.value !== nextProps.value) this.broadcast.publish(nextProps.value);
  };

  Broadcast.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Broadcast;
}(_react2.default.Component);

Broadcast.contextTypes = {
  broadcasts: _react.PropTypes.object
};
Broadcast.childContextTypes = {
  broadcasts: _react.PropTypes.object.isRequired
};


if (false) {
  Broadcast.propTypes = {
    channel: _react.PropTypes.string.isRequired,
    children: _react.PropTypes.node.isRequired,
    value: _react.PropTypes.any
  };
}

exports.default = Broadcast;

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A <Subscriber> pulls the value for a channel off of context.broadcasts
 * and passes it to its children function.
 */
var Subscriber = function (_React$Component) {
  _inherits(Subscriber, _React$Component);

  function Subscriber() {
    var _temp, _this, _ret;

    _classCallCheck(this, Subscriber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      value: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Subscriber.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var channel = this.props.channel;


    if (this.context.broadcasts) {
      var subscribe = this.context.broadcasts[channel];

      !(typeof subscribe === 'function') ?  false ? (0, _invariant2.default)(false, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', channel, channel) : (0, _invariant2.default)(false) : void 0;

      this.unsubscribe = subscribe(function (value) {
        // This function will be called once immediately.
        _this2.setState({ value: value });
      });
    }
  };

  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  };

  Subscriber.prototype.render = function render() {
    return this.props.children(this.state.value);
  };

  return Subscriber;
}(_react2.default.Component);

Subscriber.contextTypes = {
  broadcasts: _react2.default.PropTypes.object
};


if (false) {
  Subscriber.propTypes = {
    channel: _react.PropTypes.string.isRequired,
    children: _react.PropTypes.func.isRequired
  };
}

exports.default = Subscriber;

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * FocalPoint
 * The container that will maintain focus
 */

var React = __webpack_require__(5);
var stack = [];
var timer = null;

/**
 * To support server-side rendering, do not push the active element
 * when not in the browser environment
 */
if (typeof document !== 'undefined' && document.activeElement) {
  stack.push(document.activeElement);
}

var FocalPoint = function (_React$Component) {
  _inherits(FocalPoint, _React$Component);

  function FocalPoint() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocalPoint);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocalPoint.__proto__ || Object.getPrototypeOf(FocalPoint)).call.apply(_ref, [this].concat(args))), _this), _this._onBlur = function (event) {
      var current = stack[stack.length - 1];

      if (current && current.contains(event.target) === false) {
        event.preventDefault();
        _this.trapFocus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocalPoint, [{
    key: 'contains',
    value: function contains(element) {
      return this.refs.root.contains(element);
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.contains(document.activeElement) === false) {
        this.refs.root.focus();
      }
    }
  }, {
    key: 'trapFocus',
    value: function trapFocus(e) {
      clearTimeout(timer);
      timer = setTimeout(function (_) {
        return stack[stack.length - 1].focus();
      }, 10);
    }
  }, {
    key: 'returnFocus',
    value: function returnFocus() {
      var anchor = this.state.anchor;

      // When transitioning between pages using hash route state,
      // this anchor is some times lost. Do not attempt to focus
      // on a non-existent anchor.

      if (anchor && (typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor)) === 'object' && typeof anchor.focus === 'function') {
        anchor.focus();
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof document !== 'undefined') {
        this.setState({ anchor: document.activeElement });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      stack.push(this);

      this.trapFocus();

      document.addEventListener('focus', this._onBlur, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      stack = stack.filter(function (i) {
        return i !== _this2;
      });

      document.removeEventListener('focus', this._onBlur, true);

      clearTimeout(timer);

      this.returnFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Element = _props.element,
          className = _props.className;


      return React.createElement(
        Element,
        { ref: 'root', tabIndex: '0', className: className },
        children
      );
    }
  }]);

  return FocalPoint;
}(React.Component);

FocalPoint.defaultProps = {
  element: 'div'
};


module.exports = FocalPoint;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FocalPoint = __webpack_require__(1024);
var React = __webpack_require__(5);

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusTrap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call.apply(_ref, [this].concat(args))), _this), _this._onKeyUp = function (event) {
      if (event.key === 'Escape' && 'onExit' in _this.props) {
        _this.props.onExit();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusTrap, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          children = _props.children,
          element = _props.element,
          onExit = _props.onExit;


      if (!active) return null;

      return React.createElement(
        'div',
        { className: className + '-wrapper', onKeyUp: this._onKeyUp },
        React.createElement('div', {
          'aria-hidden': 'true',
          className: className + '-backdrop',
          onClick: onExit
        }),
        React.createElement(
          FocalPoint,
          { ref: 'focus', className: className, element: element },
          children
        )
      );
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  className: 'focus-trap'
};


module.exports = FocusTrap;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.warn = exports.requestIdleCallback = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(1019);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(981);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var requestIdleCallback = function () {
    if (typeof window !== "undefined" && typeof window.requestIdleCallback !== "undefined") {
        return window.requestIdleCallback;
    }

    return function (cb) {
        var start = Date.now();
        return setTimeout(function () {
            cb({
                didTimeout: false,
                timeRemaining: function timeRemaining() {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };
}();

var cancelIdleCallback = function () {
    if (typeof window !== "undefined" && typeof window.cancelIdleCallback !== "undefined") {
        return window.cancelIdleCallback;
    }

    return function (id) {
        return clearTimeout(id);
    };
}();

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetIdleCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;


    if (_helmetIdleCallback) {
        cancelIdleCallback(_helmetIdleCallback);
    }

    _helmetIdleCallback = requestIdleCallback(function () {
        updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
        updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

        updateTitle(title, titleAttributes);

        var tagUpdates = {
            baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
            linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
            metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
            noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
            scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
            styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
        };

        var addedTags = {};
        var removedTags = {};

        Object.keys(tagUpdates).forEach(function (tagType) {
            var _tagUpdates$tagType = tagUpdates[tagType],
                newTags = _tagUpdates$tagType.newTags,
                oldTags = _tagUpdates$tagType.oldTags;


            if (newTags.length) {
                addedTags[tagType] = newTags;
            }
            if (oldTags.length) {
                removedTags[tagType] = tagUpdates[tagType].oldTags;
            }
        });

        _helmetIdleCallback = null;
        onChangeClientState(newState, addedTags, removedTags);
    });
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = Array.isArray(title) ? title.join("") : title;
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestIdleCallback = requestIdleCallback;
exports.warn = warn;

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(965);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(962);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(967);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(961);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(964);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(966);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(965);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(962);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(967);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(961);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(964);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(966);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(965);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(962);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(967);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1030);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(961);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(964);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(966);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(982);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enabled = false;

var ScrollTop = function (_React$Component) {
  (0, _inherits3.default)(ScrollTop, _React$Component);

  function ScrollTop() {
    (0, _classCallCheck3.default)(this, ScrollTop);
    return (0, _possibleConstructorReturn3.default)(this, (ScrollTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollTop)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScrollTop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (enabled) {
        window.scrollTo(0, 0);
      } else {
        enabled = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollTop;
}(_react2.default.Component);

exports.default = ScrollTop;

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(61);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = __webpack_require__(1055);

var _debounce3 = _interopRequireDefault(_debounce2);

var _isEqual2 = __webpack_require__(423);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(273);

var _Linear = __webpack_require__(1049);

var _Linear2 = _interopRequireDefault(_Linear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cleanFormats(formats) {
  return formats.map(function (format) {
    return {
      size: format.width,
      url: format.url
    };
  });
}

var _ref = (0, _jsx3.default)(_Linear2.default, {});

var Picture = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(Picture, _React$PureComponent);

  function Picture(props) {
    (0, _classCallCheck3.default)(this, Picture);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Picture.__proto__ || (0, _getPrototypeOf2.default)(Picture)).call(this, props));

    _this.loadImage = function () {
      window.loadImage(_this._imgContainer);
    };

    _this.loadImage = (0, _debounce3.default)(_this.loadImage, 250, { leading: true });
    _this.state = { mounted: false };
    return _this;
  }

  (0, _createClass3.default)(Picture, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cleanedFormats = cleanFormats(this.props.picture.formats);
      var nextCleanedFormats = cleanFormats(nextProps.picture.formats);

      if (!(0, _isEqual3.default)(cleanedFormats, nextCleanedFormats)) {
        if (this && this._imgContainer) {
          this._imgContainer.innerHTML = '';
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      window.loadImage(this._imgContainer);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
      this.loadImage();
      window.addEventListener('resize', this.loadImage);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.loadImage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          picture = _props.picture,
          rounded = _props.rounded,
          useLoader = _props.useLoader;

      var ratio = picture.width / picture.height;
      var heightPercentage = 100 * ratio;

      var baseWrapperStyles = (0, _glamor.style)({
        backgroundColor: '#eee',
        width: '100%',
        position: 'relative',
        overflow: 'hidden'
      });

      var wrapperStyles = rounded ? (0, _glamor.merge)(baseWrapperStyles, (0, _glamor.style)({ borderRadius: '50%' })) : baseWrapperStyles;

      var baseImageStyles = (0, _glamor.style)({
        '> img': {
          position: 'absolute',
          width: '100%',
          height: '100%',
          verticalAlign: 'bottom',
          display: 'block'
        }
      });

      var imageStyles = rounded ? (0, _glamor.merge)(baseImageStyles, (0, _glamor.style)({
        '> img': { borderRadius: '50%' }
      })) : baseImageStyles;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, wrapperStyles, { style: { paddingBottom: heightPercentage + '%' } }),
        useLoader && this.state.mounted && _react2.default.createElement(
          'div',
          (0, _glamor.style)({
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }),
          _ref
        ),
        _react2.default.createElement('div', (0, _extends3.default)({}, imageStyles, { ref: function ref(element) {
            return _this2._imgContainer = element;
          },
          'data-picture': true,
          'data-formats': (0, _stringify2.default)(cleanFormats(picture.formats)) }))
      );
    }
  }]);
  return Picture;
}(_react2.default.PureComponent), _class.defaultProps = {
  rounded: false,
  useLoader: false,
  lazyloadOffset: 0,
  scrollDelay: 250
}, _temp);
exports.default = _reactRelay2.default.createContainer(Picture, {
  fragments: {
    picture: function picture() {
      return function () {
        return {
          children: [{
            fieldName: 'url',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'width',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'height',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            children: [{
              fieldName: 'url',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'width',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }, {
              fieldName: 'height',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }],
            fieldName: 'formats',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isPlural: true
            },
            type: 'PictureFormat'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Picture_PictureRelayQL',
          type: 'Picture'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _isSold = __webpack_require__(1050);

var _isSold2 = _interopRequireDefault(_isSold);

var _InvalidProductListItem = __webpack_require__(1057);

var _InvalidProductListItem2 = _interopRequireDefault(_InvalidProductListItem);

var _ProductLink = __webpack_require__(1062);

var _ProductLink2 = _interopRequireDefault(_ProductLink);

var _Picture = __webpack_require__(1039);

var _Picture2 = _interopRequireDefault(_Picture);

var _glamor = __webpack_require__(273);

var _money = __webpack_require__(1059);

var _tracking = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_InvalidProductListItem2.default, {});

var ProductListItem = function (_React$Component) {
  (0, _inherits3.default)(ProductListItem, _React$Component);

  function ProductListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProductListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProductListItem.__proto__ || (0, _getPrototypeOf2.default)(ProductListItem)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function () {
      (0, _tracking.trackProductCardClick)({
        id: _this.props.product.publicId,
        index: _this.props.productListIndex,
        listName: _this.props.listName
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProductListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          from = _props.from,
          productListIndex = _props.productListIndex;


      if (!product.picture) {
        return _ref2;
      }

      return _react2.default.createElement(
        _ProductLink2.default,
        (0, _extends3.default)({}, (0, _glamor.style)({ position: 'relative', textDecoration: 'none', color: 'inherit' }), {
          product: product,
          onClick: this.trackClick,
          from: from,
          listIndex: productListIndex }),
        _react2.default.createElement(
          'div',
          (0, _glamor.style)({ position: 'relative', background: 'black' }),
          _react2.default.createElement(
            'div',
            (0, _glamor.active)({ opacity: '0.8' }),
            (0, _jsx3.default)(_Picture2.default, {
              picture: product.picture
            })
          ),
          (0, _isSold2.default)(product) ? _react2.default.createElement(
            'div',
            (0, _glamor.style)({
              position: 'absolute',
              fontSize: 14,
              bottom: 0,
              left: 0,
              backgroundColor: '#f9ec00',
              color: '#000',
              padding: '4px 15px'
            }),
            'Sold'
          ) : null
        ),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, (0, _glamor.style)({
            display: 'none',
            margin: '10px 0 calc(10px - 0.5vw)',
            maxWidth: '100%',
            width: '12em',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontSize: 14,
            textOverflow: 'ellipsis'
          }), (0, _glamor.media)('(min-width: 701px)', { display: 'block' })),
          (0, _money.formatProductPrice)(product.price.display, product.price.currencySymbol)
        )
      );
    }
  }]);
  return ProductListItem;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(ProductListItem, {
  fragments: {
    product: function product() {
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'saleStatus',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            children: [{
              fieldName: 'currencySymbol',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'display',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'price',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true
            },
            type: 'ProductPrice'
          }, {
            children: [].concat.apply([], [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }, _reactRelay2.default.QL.__frag(RQL_1)]),
            fieldName: 'picture',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Picture'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ProductListItem_ProductRelayQL',
          type: 'Product'
        };
      }(_ProductLink2.default.getFragment('product'), _Picture2.default.getFragment('picture'));
    }
  }
});

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _InfiniteScroll = __webpack_require__(1063);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _Ball = __webpack_require__(1076);

var _Ball2 = _interopRequireDefault(_Ball);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_Ball2.default, {});

var SimpleInfiniteScroll = function SimpleInfiniteScroll(_ref) {
  var children = _ref.children,
      hasMore = _ref.hasMore,
      loadMore = _ref.loadMore,
      _ref$useWindow = _ref.useWindow,
      useWindow = _ref$useWindow === undefined ? true : _ref$useWindow;
  return (0, _jsx3.default)(_InfiniteScroll2.default, {
    style: { maxWidth: '100%' },
    pageStart: 0,
    loadMore: loadMore,
    hasMore: hasMore,
    loader: _ref2,
    useWindow: useWindow,
    threshold: 500
  }, void 0, children);
};

exports.default = SimpleInfiniteScroll;

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(275),
    isSymbol = __webpack_require__(971);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGrid = exports.ListVertical = undefined;

var _ListVertical2 = __webpack_require__(1075);

var _ListVertical3 = _interopRequireDefault(_ListVertical2);

var _ListGrid2 = __webpack_require__(1074);

var _ListGrid3 = _interopRequireDefault(_ListGrid2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ListVertical = _ListVertical3.default;
exports.ListGrid = _ListGrid3.default;

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var outer = (0, _glamor.style)({
  overflow: 'hidden',
  width: '50%',
  height: 4,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  borderRadius: 2
});

var inner = (0, _glamor.style)({
  position: 'relative',
  width: '100%',
  height: '100%'
});

var beforeAnimation = (0, _glamor.keyframes)({
  '0%': { left: '-100%', width: '100%' },
  '100%': { left: '100%', width: '10%' }
});

var afterAnimation = (0, _glamor.keyframes)({
  '0%': { left: '-150%', width: '100%' },
  '100%': { left: '100%', width: '10%' }
});

var loaderBefore = (0, _glamor.style)({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  animation: beforeAnimation + ' 1.5s infinite ease-out'
});

var loaderAfter = (0, _glamor.style)({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  animation: afterAnimation + ' 1.5s infinite ease-out'
});

exports.default = function () {
  return _react2.default.createElement(
    'div',
    outer,
    _react2.default.createElement(
      'div',
      inner,
      _react2.default.createElement('div', loaderBefore),
      _react2.default.createElement('div', loaderAfter)
    )
  );
};

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSold;
var soldStates = ['MARKED_AS_SOLD', 'PURCHASED', 'PRODUCT_BANNED_PURCHASED', 'USER_BANNED_PURCHASED'];

function isSold(product) {
  return soldStates.indexOf(product.saleStatus) !== -1;
}

/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(275),
    now = __webpack_require__(1056),
    toNumber = __webpack_require__(1045);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(62);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(188);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'ProductListItem.cannotBeDisplayed',
  description: 'Shown on a product in a list, if it can\'t be shown for some reason',
  defaultMessage: 'This product cannot be displayed.'
});

var InvalidProductListItem = function InvalidProductListItem() {
  return _react2.default.createElement(
    'div',
    (0, _glamor.style)({
      width: '100%',
      paddingBottom: '100%',
      position: 'relative',
      backgroundColor: '#fff'
    }),
    _react2.default.createElement(
      'div',
      (0, _glamor.style)({
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '14px',
        padding: '10px',
        top: '0',
        bottom: '0',
        right: '0',
        left: '0'
      }),
      _ref
    )
  );
};

exports.default = InvalidProductListItem;

/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(80);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = isProductViewable;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var acceptableStates = ['ONSALE', 'PURCHASED', 'MARKED_AS_SOLD'];

var listMandatoryFields = ['slug', 'publicId', 'saleStatus', 'description', 'dateUpdated'];

var detailMandatoryFields = [].concat(listMandatoryFields, ['seller', 'pictures', 'counters', 'price']);

function isProductViewable(product, isDetail) {
  var checkFields = isDetail ? detailMandatoryFields : listMandatoryFields;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(checkFields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;

      if (!product[field]) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (!(acceptableStates.indexOf(product.saleStatus) !== -1)) {
    return false;
  }

  return true;
}

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatProductPrice = formatProductPrice;

var _accounting = __webpack_require__(1061);

function chopPennies(string) {
  if (string.endsWith('.00')) {
    return string.substr(0, string.length - 3);
  } else {
    return string;
  }
}

function formatProductPrice(price, currency) {
  return chopPennies((0, _accounting.formatMoney)(price, currency));
}

/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(121);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildProductLocation = buildProductLocation;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRouter = __webpack_require__(60);

var _recompose = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildProductLocation(slug, id, from, listIndex) {
  return {
    pathname: '/products/' + slug,
    state: {
      productId: id,
      from: from,
      listIndex: listIndex
    }
  };
}

var ProductLink = function ProductLink(_ref) {
  var product = _ref.product,
      from = _ref.from,
      relay = _ref.relay,
      listIndex = _ref.listIndex,
      props = (0, _objectWithoutProperties3.default)(_ref, ['product', 'from', 'relay', 'listIndex']);
  return _react2.default.createElement(_reactRouter.Link, (0, _extends3.default)({ to: buildProductLocation(product.slug, product.publicId, from, listIndex) }, props));
};

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(ProductLink), {
  fragments: {
    product: function product() {
      return function () {
        return {
          children: [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ProductLink_ProductRelayQL',
          type: 'Product'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _contextWrappers = __webpack_require__(983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfiniteScroll = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(InfiniteScroll, _React$Component);

  function InfiniteScroll(props) {
    (0, _classCallCheck3.default)(this, InfiniteScroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteScroll.__proto__ || (0, _getPrototypeOf2.default)(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.attachScrollListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          element = _props.element,
          hasMore = _props.hasMore,
          loader = _props.loader,
          style = _props.style;


      var ref = function ref(node) {
        _this2.scrollComponent = node;
      };

      var showLoader = hasMore && !(this.props.location.query && this.props.location.query.hasOwnProperty('disablePaging'));

      return _react2.default.createElement(element, { style: style, ref: ref }, children, showLoader && (loader || this._defaultLoader));
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;

      var offset = void 0;
      if (this.props.useWindow) {
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateTopPosition(el) + el.offsetHeight - scrollTop - window.innerHeight;
        }
      } else {
        if (this.props.isReverse) {
          offset = el.parentNode.scrollTop;
        } else {
          offset = el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight;
        }
      }

      if (offset < Number(this.props.threshold)) {
        this.detachScrollListener();
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          if (this.props.location.query && this.props.location.query.hasOwnProperty('disablePaging')) {
            return;
          }
          this.props.loadMore(this.pageLoaded += 1);
        }
      }
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      if (!this.props.hasMore) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow == false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.addEventListener('scroll', this.scrollListener);
      scrollEl.addEventListener('resize', this.scrollListener);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow == false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('scroll', this.scrollListener);
      scrollEl.removeEventListener('resize', this.scrollListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this._defaultLoader = loader;
    }
  }]);
  return InfiniteScroll;
}(_react2.default.Component), _class.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  threshold: 250,
  useWindow: true,
  isReverse: false
}, _temp);
exports.default = (0, _contextWrappers.withLocation)(InfiniteScroll);

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _list = __webpack_require__(1048);

var _isProductViewable = __webpack_require__(1058);

var _isProductViewable2 = _interopRequireDefault(_isProductViewable);

var _ProductListItem = __webpack_require__(1041);

var _ProductListItem2 = _interopRequireDefault(_ProductListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductList = function (_React$Component) {
  (0, _inherits3.default)(ProductList, _React$Component);

  function ProductList() {
    (0, _classCallCheck3.default)(this, ProductList);
    return (0, _possibleConstructorReturn3.default)(this, (ProductList.__proto__ || (0, _getPrototypeOf2.default)(ProductList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProductList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          listName = _props.listName,
          products = _props.products,
          _props$compact = _props.compact,
          compact = _props$compact === undefined ? false : _props$compact,
          from = _props.from;


      var filteredProducts = products.filter(function (product) {
        return (0, _isProductViewable2.default)(product);
      });

      return (0, _jsx3.default)(_list.ListGrid, {
        compact: compact
      }, void 0, filteredProducts.map(function (product, iterator) {
        return (0, _jsx3.default)(_ProductListItem2.default, {
          from: from,
          product: product,
          listName: listName,
          productListIndex: iterator
        }, product.id);
      }));
    }
  }]);
  return ProductList;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(ProductList, {
  fragments: {
    products: function products() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, {
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'saleStatus',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'description',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'dateUpdated',
            kind: 'Field',
            metadata: {},
            type: 'Date'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {
            plural: true
          },
          name: 'ProductList_ProductsRelayQL',
          type: 'Product'
        };
      }(_ProductListItem2.default.getFragment('product'));
    }
  }
});

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListItem = exports.ProductList = undefined;

var _ProductList2 = __webpack_require__(1064);

var _ProductList3 = _interopRequireDefault(_ProductList2);

var _ProductListItem2 = __webpack_require__(1041);

var _ProductListItem3 = _interopRequireDefault(_ProductListItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProductList = _ProductList3.default;
exports.ProductListItem = _ProductListItem3.default;

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = ListGrid;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListGrid(_ref) {
  var children = _ref.children,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? false : _ref$compact;

  if (compact) {
    return _react2.default.createElement(
      'ul',
      (0, _extends3.default)({}, (0, _glamor.css)({ margin: '0 -0.5vw', padding: '0', listStyle: 'none', overflow: 'auto' }), (0, _glamor.after)({ content: '\'\'', display: 'table', clear: 'both' })),
      children.map(function (child) {
        return _react2.default.createElement(
          'li',
          (0, _extends3.default)({ key: child.key
          }, (0, _glamor.css)({ display: 'block', padding: '0.5vw', float: 'left', width: 'calc(100% / 3)' })),
          child
        );
      })
    );
  }

  return _react2.default.createElement(
    'ul',
    (0, _extends3.default)({}, (0, _glamor.css)({ margin: '0 -0.5vw', padding: 0, listStyle: 'none', overflow: 'auto' }), (0, _glamor.media)('(min-width: 700px)', { margin: '0 -1vw' }), (0, _glamor.media)('(min-width: 1000px)', { margin: '0 -1.2vw' }), (0, _glamor.after)({ content: '\'\'', display: 'table', clear: 'both' })),
    children.map(function (child) {
      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({ key: child.key
        }, (0, _glamor.css)({ display: 'block', padding: '0.5vw', float: 'left', width: 'calc(100% / 3)' }), (0, _glamor.media)('(min-width: 700px)', { padding: '0.5vw 1vw', width: 'calc(100% / 4)' }), (0, _glamor.media)('(min-width: 1000px)', { padding: '0.5vw 1.2vw', width: 'calc(100% / 6)' }), (0, _glamor.media)('(min-width: 1701px)', { padding: '0.5vw 1.2vw', width: 'calc(100% / 8)' })),
        child
      );
    })
  );
}

/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = ListVertical;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListVertical(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'ul',
    (0, _glamor.style)({ listStyleType: 'none' }),
    children.map(function (child) {
      return (0, _jsx3.default)('li', {}, child.key, child);
    })
  );
}

/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bounce = (0, _glamor.keyframes)('bounce', { // optional name
  '0%': { transform: 'translateX(0)' },
  '50%': { transform: 'translateX(2rem)' },
  '100%': { transform: 'translateX(0)' }
});

exports.default = function () {
  return _react2.default.createElement(
    'div',
    (0, _glamor.style)({
      position: 'relative',
      width: '3rem',
      height: '3rem',
      margin: '20px auto',
      overflow: 'hidden'
    }),
    _react2.default.createElement('div', (0, _glamor.style)({
      animationName: bounce,
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-in-out',
      background: '#f00',
      width: '1rem',
      height: '1rem',
      position: 'absolute',
      top: '1rem',
      left: 0,
      borderRadius: '50%'
    }))
  );
};

/***/ }),

/***/ 1185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _SimpleInfiniteScroll = __webpack_require__(1042);

var _SimpleInfiniteScroll2 = _interopRequireDefault(_SimpleInfiniteScroll);

var _ProductList = __webpack_require__(1065);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeaturedProducts = function (_React$PureComponent) {
  (0, _inherits3.default)(FeaturedProducts, _React$PureComponent);

  function FeaturedProducts() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeaturedProducts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeaturedProducts.__proto__ || (0, _getPrototypeOf2.default)(FeaturedProducts)).call.apply(_ref, [this].concat(args))), _this), _this.loadMore = function () {
      var numResults = _this.props.relay.variables.numResults + 24;

      _this.props.relay.setVariables({
        numResults: numResults
      });

      _this.props.loadedMore && _this.props.loadedMore(numResults);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeaturedProducts, [{
    key: 'render',
    value: function render() {
      var viewer = this.props.viewer;
      var products = viewer.suggested.products;


      return (0, _jsx3.default)(_SimpleInfiniteScroll2.default, {
        loadMore: this.loadMore,
        hasMore: products.pageInfo.hasNextPage
      }, void 0, (0, _jsx3.default)(_ProductList.ProductList, {
        from: 'browse',
        listName: 'Explore',
        products: products.edges.map(function (edge) {
          return edge.node;
        })
      }));
    }
  }]);
  return FeaturedProducts;
}(_react2.default.PureComponent);

exports.default = _reactRelay2.default.createContainer(FeaturedProducts, {
  initialVariables: {
    numResults: null
  },
  fragments: {
    viewer: function viewer() {
      return function (RQL_0) {
        return {
          children: [{
            children: [{
              calls: [{
                kind: 'Call',
                metadata: {
                  type: 'Int'
                },
                name: 'first',
                value: {
                  kind: 'CallVariable',
                  callVariableName: 'numResults'
                }
              }],
              children: [{
                children: [{
                  children: [].concat.apply([], [{
                    fieldName: 'id',
                    kind: 'Field',
                    metadata: {
                      isGenerated: true,
                      isRequisite: true
                    },
                    type: 'ID'
                  }, _reactRelay2.default.QL.__frag(RQL_0)]),
                  fieldName: 'node',
                  kind: 'Field',
                  metadata: {
                    canHaveSubselections: true,
                    inferredRootCallName: 'node',
                    inferredPrimaryKey: 'id',
                    isRequisite: true
                  },
                  type: 'Product'
                }, {
                  fieldName: 'cursor',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'String'
                }],
                fieldName: 'edges',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  isPlural: true
                },
                type: 'ProductEdge'
              }, {
                children: [{
                  fieldName: 'hasNextPage',
                  kind: 'Field',
                  metadata: {
                    isRequisite: true
                  },
                  type: 'Boolean'
                }, {
                  fieldName: 'hasPreviousPage',
                  kind: 'Field',
                  metadata: {
                    isGenerated: true,
                    isRequisite: true
                  },
                  type: 'Boolean'
                }],
                fieldName: 'pageInfo',
                kind: 'Field',
                metadata: {
                  canHaveSubselections: true,
                  isRequisite: true
                },
                type: 'PageInfo'
              }],
              fieldName: 'products',
              kind: 'Field',
              metadata: {
                canHaveSubselections: true,
                isConnection: true
              },
              type: 'ProductConnection'
            }],
            fieldName: 'suggested',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true
            },
            type: 'Suggested'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'FeaturedProducts_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_ProductList.ProductList.getFragment('products'));
    }
  }
});

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(273);

var _reactIntl = __webpack_require__(188);

var _Deeplink = __webpack_require__(987);

var _Deeplink2 = _interopRequireDefault(_Deeplink);

var _Application = __webpack_require__(984);

var _Application2 = _interopRequireDefault(_Application);

var _scroll = __webpack_require__(986);

var _FeaturedProducts = __webpack_require__(1185);

var _FeaturedProducts2 = _interopRequireDefault(_FeaturedProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_scroll.ScrollTop, {});

var _ref3 = (0, _jsx3.default)(_Deeplink2.default, {
  path: 'explore',
  referer: '',
  canonicalUrl: 'https://www.depop.com/'
});

var _ref4 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'Homepage.greeting',
  description: 'Greeting to welcome the user to the website',
  defaultMessage: 'Hello, we\'re open. Hello we\'re Depop. We inspire people to find things they love. We believe in passion, creativity and connection. We believe that shopping should be fun and easy. Create your own shop, discover and share your favorite things. Welcome to our community.'
});

var _ref5 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'Homepage.exploreHeading',
  description: 'Heading for explore feed',
  defaultMessage: 'Explore items'
});

var Homepage = function (_React$Component) {
  (0, _inherits3.default)(Homepage, _React$Component);

  function Homepage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Homepage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Homepage.__proto__ || (0, _getPrototypeOf2.default)(Homepage)).call.apply(_ref, [this].concat(args))), _this), _this.loadMore = function (numResults) {
      window.history.replaceState((0, _extends3.default)({}, window.history.state, {
        numResults: numResults
      }), null, null);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Homepage, [{
    key: 'render',
    value: function render() {
      var viewer = this.props.viewer;


      return (0, _jsx3.default)(_Application2.default, {
        viewer: viewer
      }, void 0, _ref2, _ref3, !viewer.currentUser && (0, _jsx3.default)('p', {
        style: {
          fontSize: 14,
          margin: '0 0 2em',
          maxWidth: '40em',
          lineHeight: '1.3'
        }
      }, void 0, _ref4), _react2.default.createElement(
        'h1',
        (0, _glamor.css)({ marginBottom: 20 }),
        _ref5
      ), (0, _jsx3.default)(_FeaturedProducts2.default, {
        viewer: viewer,
        loadedMore: this.loadMore,
        numResults: this.props.relay.variables.numResults
      }));
    }
  }]);
  return Homepage;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(Homepage, {
  initialVariables: {
    numResults: null
  },
  fragments: {
    viewer: function viewer(_ref6) {
      var numResults = _ref6.numResults;
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            children: [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Homepage_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_Application2.default.getFragment('viewer'), _FeaturedProducts2.default.getFragment('viewer', { numResults: numResults }));
    }
  }
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEagerElement", function() { return createEagerElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEagerFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_symbol_observable__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component$$1 = type;

  if (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Component$$1,
      props,
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component$$1, props);
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && _typeof(Component$$1.prototype.isReactComponent) === 'object');
};

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component$$1) {
  return Boolean(typeof Component$$1 === 'function' && !isClassComponent(Component$$1) && !Component$$1.defaultProps && !Component$$1.contextTypes && ("production" === 'production' || !Component$$1.propTypes));
};

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
  return function (p, c) {
    return createEagerElementUtil(false, isReferentiallyTransparent, type, p, c);
  };
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

/* eslint-disable no-console */
var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || createFactory(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || createFactory(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = createFactory(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Nothing.displayName = 'Nothing';

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));

        Object.assign(_this, spec);
        return _this;
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createEagerElement = function createEagerElement(type, props, children) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
  /* eslint-disable */
  var hasKey = props && props.hasOwnProperty('key');
  /* eslint-enable */
  return createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children);
};

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return createEagerElement(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(createFactory);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = createFactory(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(60);

var _recompose = __webpack_require__(959);

exports.default = (0, _recompose.pure)(_reactRouter.Link);

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(418)))

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, (0, _glamor.style)({
      padding: '10px 20px'
    }), (0, _glamor.media)('(min-width: 701px)', {
      padding: '10px 7.5vw'
    })),
    children
  );
};

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(961)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1017);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(1033);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(279);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(121);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(412);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(411);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Modal = __webpack_require__(975);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyModal = function (_React$Component) {
  (0, _inherits3.default)(LazyModal, _React$Component);

  function LazyModal(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, LazyModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyModal.__proto__ || (0, _getPrototypeOf2.default)(LazyModal)).call(this, props));

    _this.load = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var result;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.load();

            case 2:
              result = _context.sent;

              _this.setState({ ready: true, result: result });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = { ready: false, result: null };
    return _this;
  }

  (0, _createClass3.default)(LazyModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpened && !this.state.ready) {
        this.load();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isOpened && !this.state.ready) {
        this.load();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          render = _props.render,
          props = (0, _objectWithoutProperties3.default)(_props, ['isOpened', 'render']);
      var _state = this.state,
          ready = _state.ready,
          result = _state.result;


      return _react2.default.createElement(_Modal2.default, (0, _extends3.default)({}, props, { isOpened: ready && isOpened, render: function (_render) {
          function render() {
            return _render.apply(this, arguments);
          }

          render.toString = function () {
            return _render.toString();
          };

          return render;
        }(function () {
          return render(result);
        }) }));
    }
  }]);
  return LazyModal;
}(_react2.default.Component);

exports.default = LazyModal;

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(145),
    isObjectLike = __webpack_require__(146);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(968);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(417);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(1026);

var _HelmetConstants = __webpack_require__(981);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withNotifications = exports.NotificationsProvider = undefined;

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__(969);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniqueId2 = __webpack_require__(998);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactBroadcast = __webpack_require__(980);

var _recompose = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsProvider = exports.NotificationsProvider = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(NotificationsProvider, _React$Component);

  function NotificationsProvider(props) {
    (0, _classCallCheck3.default)(this, NotificationsProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationsProvider.__proto__ || (0, _getPrototypeOf2.default)(NotificationsProvider)).call(this, props));

    _this.addNotification = function (text) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

      _this.setState(function (_ref) {
        var notifications = _ref.notifications;

        var id = (0, _uniqueId3.default)();

        setTimeout(function () {
          return _this.removeNotification(id);
        }, 5000);

        return {
          notifications: [].concat((0, _toConsumableArray3.default)(notifications), [{
            id: id,
            content: text,
            status: status
          }])
        };
      });
    };

    _this.removeNotification = function (id) {
      _this.setState(function (_ref2) {
        var notifications = _ref2.notifications;

        var index = notifications.findIndex(function (notification) {
          return notification.id === id;
        });

        if (index < 0) {
          return;
        }

        return {
          notifications: [].concat((0, _toConsumableArray3.default)(notifications.slice(0, index)), (0, _toConsumableArray3.default)(notifications.slice(index + 1)))
        };
      });
    };

    _this.state = {
      notifications: []
    };
    return _this;
  }

  (0, _createClass3.default)(NotificationsProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        addNotification: this.addNotification,
        removeNotification: this.removeNotification
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _jsx3.default)(_reactBroadcast.Broadcast, {
        channel: 'notifications',
        value: this.state.notifications
      }, void 0, this.props.children);
    }
  }]);
  return NotificationsProvider;
}(_react2.default.Component), _class.childContextTypes = {
  addNotification: _react2.default.PropTypes.func,
  removeNotification: _react2.default.PropTypes.func
}, _temp);


var withNotifications = (0, _recompose.getContext)({
  addNotification: _react2.default.PropTypes.func,
  removeNotification: _react2.default.PropTypes.func
});

exports.withNotifications = withNotifications;
exports.default = NotificationsProvider;

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLink = exports.sendSMS = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(412);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(411);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(143);

var _promise2 = _interopRequireDefault(_promise);

exports.isClient = isClient;
exports.isBannerPlatform = isBannerPlatform;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isClient() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

function isBannerPlatform(platform) {
  var bannerPlatforms = ['iPhone', 'iPod', 'iPad', 'Android'];
  if (bannerPlatforms.indexOf(platform) !== -1) {
    return true;
  }
  return false;
}

var initBranch = function initBranch() {
  return new _promise2.default(function (resolve, reject) {
    __webpack_require__(1015).default;
    var configData = JSON.parse(document.getElementById('configData').textContent);
    var branchKey = configData.analytics.branch;
    window.branch.init(branchKey, {}, function (err, data) {
      if (err) {
        reject(err);
        return;
      }
      resolve(window.branch);
    });
  });
};

var getBranch = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isClient()) {
              _context.next = 6;
              break;
            }

            if (!(typeof window.branch !== 'undefined')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', window.branch);

          case 3:
            _context.next = 5;
            return initBranch();

          case 5:
            return _context.abrupt('return', _context.sent);

          case 6:
            return _context.abrupt('return', false);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getBranch() {
    return _ref.apply(this, arguments);
  };
}();

var sendSMS = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(number, deeplink, referrer, callback) {
    var branch;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getBranch();

          case 2:
            branch = _context2.sent;


            if (branch) {
              branch.sendSMS(number, {
                data: {
                  '$deeplink_path': deeplink,
                  'referring_user': referrer
                }
              }, {
                make_new_link: true
              }, callback);
            }

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function sendSMS(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var createLink = function () {
  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(linkPath, refer, params, callback) {
    var branch;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getBranch();

          case 2:
            branch = _context3.sent;


            if (branch) {
              branch.link((0, _extends3.default)({}, params, {
                data: {
                  'referring_user': refer,
                  '$deeplink_path': linkPath
                }
              }), function (err, link) {
                if (link) {
                  callback(link);
                  return true;
                }
                console.error(err);
                return false;
              });
            }

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function createLink(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

exports.sendSMS = sendSMS;
exports.createLink = createLink;

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(995);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalShell = __webpack_require__(976);

var _ModalShell2 = _interopRequireDefault(_ModalShell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal(_ref) {
  var render = _ref.render,
      trigger = _ref.trigger,
      isOpened = _ref.isOpened,
      onClose = _ref.onClose;

  return (0, _jsx3.default)(_Portal2.default, {
    closeOnEsc: true,
    openByClickOn: trigger,
    isOpened: isOpened,
    onClose: onClose,
    render: function (_render) {
      function render() {
        return _render.apply(this, arguments);
      }

      render.toString = function () {
        return _render.toString();
      };

      return render;
    }(function () {
      return (0, _jsx3.default)(_ModalShell2.default, {}, void 0, render());
    })
  });
}

exports.default = Modal;

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(144);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(959);

var _glamor = __webpack_require__(273);

var _reactFocusTrap = __webpack_require__(1025);

var _reactFocusTrap2 = _interopRequireDefault(_reactFocusTrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalShell = function (_React$Component) {
  (0, _inherits3.default)(ModalShell, _React$Component);

  function ModalShell(props) {
    (0, _classCallCheck3.default)(this, ModalShell);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalShell.__proto__ || (0, _getPrototypeOf2.default)(ModalShell)).call(this, props));

    _this.setWrapperRef = function (el) {
      _this._wrapper = el;
    };

    _this.close = function () {
      var closePortal = _this.props.closePortal;

      _this.setState({ isOpen: false });
      setTimeout(function () {
        closePortal();
      }, 200);
    };

    _this.handleCloseClick = function (event) {
      event.preventDefault();
      _this.close();
    };

    _this.state = { isOpen: false };
    return _this;
  }

  (0, _createClass3.default)(ModalShell, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window !== 'undefined') {
        document.body.classList.add('modal-open');
      }
      setTimeout(function () {
        _this2.setState({ isOpen: true });
      }, 4);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if ((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) !== undefined) {
        document.body.classList.remove('modal-open');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var isOpen = this.state.isOpen;


      var wrapperStyles = {
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        opacity: '0',
        backgroundColor: 'rgba(0, 0, 0, .5)',
        WebkitOverflowScrolling: 'touch',
        transition: 'opacity .1s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '1000',
        overflow: 'hidden'
      };

      var openWrapperStyles = (0, _extends3.default)({}, wrapperStyles, {
        opacity: '1'
      });

      var rootStyles = {
        width: '400px',
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        cursor: 'default',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 100px 0 rgba(0, 0, 0, .25)',
        transition: '\n        transform .1s ease-in-out,\n        opacity .1s ease-in-out,\n        margin .05s ease-in-out,\n        max-width .1s ease-in-out,\n        min-height .1s ease-in-out',
        opacity: '0',
        transform: 'scale(0)'
      };

      var openRootStyles = (0, _extends3.default)({}, rootStyles, {
        transform: 'scale(1)',
        opacity: '1'
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          ref: this.setWrapperRef
        }, (0, _glamor.style)(isOpen ? openWrapperStyles : wrapperStyles), (0, _glamor.media)('(max-width: 700px)', {
          position: 'absolute',
          height: '100vh'
        })),
        _react2.default.createElement('div', (0, _extends3.default)({
          onClick: this.close
        }, (0, _glamor.style)({
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0'
        }), (0, _glamor.media)('(max-width: 700px)', {
          position: 'absolute'
        }))),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, (0, _glamor.style)(isOpen ? openRootStyles : rootStyles), (0, _glamor.media)('(max-width: 700px)', {
            width: '100%',
            height: '100%'
          })),
          (0, _jsx3.default)(_reactFocusTrap2.default, {}, void 0, _react2.default.createElement(
            'div',
            (0, _glamor.style)({
              width: '100%',
              height: '100%',
              backgroundColor: '#FFFFFF'
            }),
            _react2.default.cloneElement(children, {
              closeModal: this.close
            })
          ))
        )
      );
    }
  }]);
  return ModalShell;
}(_react2.default.Component);

exports.default = (0, _recompose.pure)(ModalShell);

/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(188);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browserCookies = __webpack_require__(414);

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _recompose = __webpack_require__(959);

var _tracking = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.logoutLabel',
  description: 'Logout Label',
  defaultMessage: 'Logout'
});

var LogoutButton = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(LogoutButton, _React$Component);

  function LogoutButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LogoutButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LogoutButton.__proto__ || (0, _getPrototypeOf2.default)(LogoutButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      event.preventDefault();

      _browserCookies2.default.erase('token');
      _this.context.resetEnvironment(function () {
        (0, _tracking.trackLogout)();
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LogoutButton, [{
    key: 'render',
    value: function render() {
      return (0, _jsx3.default)('a', {
        href: 'javascript:;',
        style: {
          textDecoration: 'none',
          color: 'inherit',
          fontWeight: 'bold'
        },
        onClick: this.handleClick
      }, void 0, _ref2);
    }
  }]);
  return LogoutButton;
}(_react2.default.Component), _class.contextTypes = {
  resetEnvironment: _propTypes2.default.func
}, _temp2);
exports.default = (0, _recompose.pure)(LogoutButton);

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

exports.arrayToObject = function (source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (Object.prototype.hasOwnProperty.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]; // eslint-disable-line max-len
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (obj[i] && typeof obj[i] === 'object') {
                compacted.push(exports.compact(obj[i], refs));
            } else if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        obj[key] = exports.compact(obj[key], refs);
    });

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Subscriber = exports.Broadcast = undefined;

var _Broadcast2 = __webpack_require__(1022);

var _Broadcast3 = _interopRequireDefault(_Broadcast2);

var _Subscriber2 = __webpack_require__(1023);

var _Subscriber3 = _interopRequireDefault(_Subscriber2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Broadcast = _Broadcast3.default;
exports.Subscriber = _Subscriber3.default;

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "accesskey": "accessKey",
    "charset": "charSet",
    "class": "className",
    "contenteditable": "contentEditable",
    "contextmenu": "contextMenu",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "tabindex": "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLocation = exports.withRouter = undefined;

var _reactRouter = __webpack_require__(60);

Object.defineProperty(exports, 'withRouter', {
  enumerable: true,
  get: function get() {
    return _reactRouter.withRouter;
  }
});

var _react = __webpack_require__(5);

var _recompose = __webpack_require__(959);

var withLocation = exports.withLocation = (0, _recompose.getContext)({ location: _react.PropTypes.object });

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _contextWrappers = __webpack_require__(983);

var _reactHelmet = __webpack_require__(972);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _recompose = __webpack_require__(959);

var _NestedStatus = __webpack_require__(985);

var _NestedStatus2 = _interopRequireDefault(_NestedStatus);

var _Container = __webpack_require__(963);

var _Container2 = _interopRequireDefault(_Container);

var _NotificationsList = __webpack_require__(1002);

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

var _modal = __webpack_require__(996);

var _NotificationsProvider = __webpack_require__(973);

var _NotificationsProvider2 = _interopRequireDefault(_NotificationsProvider);

var _UniqueIdProvider = __webpack_require__(992);

var _UniqueIdProvider2 = _interopRequireDefault(_UniqueIdProvider);

var _reactIntl = __webpack_require__(188);

var _glamor = __webpack_require__(273);

var _applyRootStyles = __webpack_require__(1014);

var _applyRootStyles2 = _interopRequireDefault(_applyRootStyles);

var _getCurrentUser = __webpack_require__(278);

var _Deeplink = __webpack_require__(987);

var _Deeplink2 = _interopRequireDefault(_Deeplink);

var _AppNavigation = __webpack_require__(1010);

var _AppNavigation2 = _interopRequireDefault(_AppNavigation);

var _DeeplinkBanner = __webpack_require__(1004);

var _DeeplinkBanner2 = _interopRequireDefault(_DeeplinkBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'Depop';
var IOS_ID = '518684914';
var ANDROID_ID = 'com.depop';
var TWITTER_ID = '380944344';
var FB_APP_ID = '127876583993492';

(0, _applyRootStyles2.default)();

var messages = (0, _reactIntl.defineMessages)({
  description: {
    'id': 'Application.defaultDescription',
    'defaultMessage': 'Depop. Sell with a snap, buy with a tap.'
  }
});

var _ref2 = (0, _jsx3.default)(_NestedStatus2.default, {
  code: 200
});

var _ref3 = (0, _jsx3.default)(_Deeplink2.default, {});

var _ref4 = (0, _jsx3.default)(_DeeplinkBanner2.default, {});

var _ref5 = (0, _jsx3.default)(_NotificationsList2.default, {});

var Application = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Application, _React$Component);

  function Application() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Application);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).call.apply(_ref, [this].concat(args))), _this), _this.handleModalClose = function () {
      var location = _this.props.location;

      _this.props.router.push(location.state.returnTo);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Application, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.key !== this.props.location.key && nextProps.location.state && nextProps.location.state.modal) {
        this.previousChildren = this.props.children;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          viewer = _props.viewer,
          location = _props.location,
          intl = _props.intl,
          hideFooter = _props.hideFooter;
      var pathname = location.pathname;


      var showSearch = !pathname.startsWith('/search');

      var isModal = location.state && location.state.modal && this.previousChildren;

      return (0, _jsx3.default)(_NotificationsProvider2.default, {}, void 0, _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, (0, _glamor.style)({
          margin: '0',
          padding: '0 0 30px 0'
        }), (0, _glamor.$)('.focus-trap-wrapper', { background: 'green' }), (0, _glamor.$)('.focus-trap', { background: 'purple' })),
        _ref2,
        (0, _jsx3.default)(_reactHelmet2.default, {
          titleTemplate: '%s - Depop',
          defaultTitle: 'Depop',
          htmlAttributes: { lang: intl.locale },
          meta: [{ name: 'charset', content: 'utf-8' }, {
            name: 'description',
            content: intl.formatMessage(messages.description)
          }, {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1'
          }, { name: 'twitter:card', content: 'app' }, { name: 'twitter:site', content: '@depop' }, { name: 'twitter:creator:id', content: TWITTER_ID }, {
            name: 'twitter:description',
            content: intl.formatMessage(messages.description)
          }, { name: 'twitter:app:id:iphone', content: IOS_ID }, { name: 'twitter:app:id:ipad', content: IOS_ID }, { name: 'twitter:app:id:googleplay', content: ANDROID_ID }, { name: 'twitter:app:name:iphone', content: NAME }, { name: 'twitter:app:name:ipad', content: NAME }, { name: 'twitter:app:name:googleplay', content: NAME }, { name: 'twitter:app:url:iphone', content: 'depop://' }, { name: 'twitter:app:url:ipad', content: 'depop://' }, {
            name: 'twitter:app:url:googleplay',
            content: 'https://play.google.com/store/apps/details?id=' + ANDROID_ID
          }, { property: 'fb:app_id', content: FB_APP_ID }]
        }),
        _ref3,
        (0, _jsx3.default)(_AppNavigation2.default, {
          showSearch: showSearch,
          viewer: viewer,
          hideFooter: hideFooter
        }),
        _react2.default.createElement(
          'div',
          (0, _glamor.style)({ padding: '0 0 30px' }),
          (0, _jsx3.default)(_Container2.default, {}, void 0, isModal ? this.previousChildren : children)
        ),
        _ref4,
        _ref5,
        isModal && (0, _jsx3.default)(_modal.Modal, {
          isOpened: true,
          onClose: this.handleModalClose,
          previous: location.state.modalPrevious,
          next: location.state.modalNext,
          render: function render() {
            return children;
          }
        })
      ));
    }
  }]);
  return Application;
}(_react2.default.Component), _class.contextTypes = {
  resetEnvironment: _react2.default.PropTypes.func
}, _temp2);


var enhance = (0, _recompose.compose)(_UniqueIdProvider2.default, _contextWrappers.withRouter, _contextWrappers.withLocation, _reactIntl.injectIntl);

exports.default = _reactRelay2.default.createContainer(enhance(Application), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Application_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_getCurrentUser.currentUserFragment, _AppNavigation2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(968);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedStatus = function (_Component) {
  (0, _inherits3.default)(NestedStatus, _Component);

  function NestedStatus() {
    (0, _classCallCheck3.default)(this, NestedStatus);
    return (0, _possibleConstructorReturn3.default)(this, (NestedStatus.__proto__ || (0, _getPrototypeOf2.default)(NestedStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(NestedStatus, [{
    key: 'render',
    value: function render() {
      if (this.props.children) {
        return this.props.children;
      } else {
        return null;
      }
    }
  }]);
  return NestedStatus;
}(_react.Component);

function handleStateChangeOnClient() {}

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.code;
  }
  return 200;
}

exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(NestedStatus);

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollTop = undefined;

var _ScrollTop2 = __webpack_require__(1035);

var _ScrollTop3 = _interopRequireDefault(_ScrollTop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ScrollTop = _ScrollTop3.default;

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(121);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(410);

var _reactSideEffect = __webpack_require__(968);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _overlays = __webpack_require__(413);

var _deeplinks = __webpack_require__(974);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Noop = function () {
  function Noop(props) {
    return null;
  }

  return Noop;
}();

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];

  if (innermostProps) {
    return innermostProps;
  }
  return {};
}

function handleStateChangeOnClient(props) {
  var update = props.update,
      config = (0, _objectWithoutProperties3.default)(props, ['update']);


  if (!update) {
    return;
  }

  if ((0, _keys2.default)(config).length > 0) {
    var path = config.path,
        referer = config.referer,
        canonicalUrl = config.canonicalUrl;


    (0, _deeplinks.createLink)(path, referer, {
      '$canonical_url': canonicalUrl,
      'channel': 'app banner'
    }, function (link) {
      update({
        path: path,
        referer: referer,
        canonicalUrl: canonicalUrl,
        link: link
      });
    });
  } else {
    update(null);
  }
}

var Wrapped = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(Noop);

var mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    update: function update(value) {
      return dispatch((0, _overlays.updateBanner)(value));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Wrapped);

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1018);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(79);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(959);

var _glamor = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo() {
  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      display: 'inline-block',
      width: '100%',
      height: '100%'
    }),
    (0, _jsx3.default)('svg', {
      width: '100%',
      height: '100%',
      viewBox: '0 0 399 120'
    }, void 0, (0, _jsx3.default)('g', {
      stroke: 'none',
      strokeWidth: '1',
      fill: 'none',
      fillRule: 'evenodd'
    }, void 0, _react2.default.createElement('path', (0, _extends3.default)({}, (0, _glamor.css)({ fill: 'red' }), { d: 'M0.204,62.448 C0.204,82.32 10.14,97.44 28.284,97.44 C44.7,97.44 50.748,85.344 53.484,74.688 L58.092,96 L70.62,96 L70.62,0.096 L49.02,0.096 L49.02,43.44 C45.42,34.944 39.228,27.456 27.708,27.456 C9.852,27.456 0.204,42.576 0.204,62.448 L0.204,62.448 Z M21.804,62.448 C21.804,50.352 26.412,41.856 35.196,41.856 C42.828,41.856 49.02,49.632 49.02,62.448 C49.02,75.264 42.828,83.04 35.196,83.04 C26.412,83.04 21.804,74.544 21.804,62.448 L21.804,62.448 Z M146.364,66.768 C147.084,63.024 147.372,58.848 147.372,56.4 C147.372,38.4 137.004,27.456 118.86,27.456 C96.252,27.456 84.3,43.296 84.3,62.448 C84.3,81.168 95.388,97.44 120.876,97.44 C135.564,97.44 147.084,91.68 148.236,77.136 L132.972,73.104 C131.676,81.456 127.356,84.048 121.02,84.048 C111.372,84.048 106.62,77.136 106.044,66.768 L146.364,66.768 Z M119.436,40.416 C126.204,40.416 129.372,45.312 129.372,52.368 C129.372,53.52 129.228,54.672 129.084,55.824 L106.332,55.824 C107.772,45.888 112.236,40.416 119.436,40.416 L119.436,40.416 Z M233.196,62.448 C233.196,42.576 223.26,27.456 205.116,27.456 C188.7,27.456 182.652,39.552 179.916,50.208 L175.308,28.896 L162.78,28.896 L162.78,119.616 L184.38,119.616 L184.38,81.456 C187.98,89.952 194.172,97.44 205.692,97.44 C223.548,97.44 233.196,82.32 233.196,62.448 L233.196,62.448 Z M211.596,62.448 C211.596,74.544 206.988,83.04 198.204,83.04 C190.572,83.04 184.38,75.264 184.38,62.448 C184.38,49.632 190.572,41.856 198.204,41.856 C206.988,41.856 211.596,50.352 211.596,62.448 L211.596,62.448 Z M314.7,62.448 C314.7,41.568 299.148,27.456 278.844,27.456 C258.396,27.456 242.988,41.568 242.988,62.448 C242.988,83.328 258.396,97.44 278.844,97.44 C299.148,97.44 314.7,83.328 314.7,62.448 L314.7,62.448 Z M293.1,62.448 C293.1,74.976 287.628,83.04 278.844,83.04 C270.06,83.04 264.588,74.976 264.588,62.448 C264.588,49.92 270.06,41.856 278.844,41.856 C287.628,41.856 293.1,49.92 293.1,62.448 L293.1,62.448 Z M398.796,62.448 C398.796,42.576 388.86,27.456 370.716,27.456 C354.3,27.456 348.252,39.552 345.516,50.208 L340.908,28.896 L328.38,28.896 L328.38,119.616 L349.98,119.616 L349.98,81.456 C353.58,89.952 359.772,97.44 371.292,97.44 C389.148,97.44 398.796,82.32 398.796,62.448 L398.796,62.448 Z M377.196,62.448 C377.196,74.544 372.588,83.04 363.804,83.04 C356.172,83.04 349.98,75.264 349.98,62.448 C349.98,49.632 356.172,41.856 363.804,41.856 C372.588,41.856 377.196,50.352 377.196,62.448 L377.196,62.448 Z' }))))
  );
};

exports.default = (0, _recompose.pure)(Logo);

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1021);
var parse = __webpack_require__(1020);
var formats = __webpack_require__(978);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withIdGenerator = exports.IDGenerator = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(189);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDGenerator = exports.IDGenerator = function () {
  function IDGenerator() {
    (0, _classCallCheck3.default)(this, IDGenerator);

    this._counter = 0;
  }

  (0, _createClass3.default)(IDGenerator, [{
    key: 'next',
    value: function next() {
      this._counter++;
      return this._counter;
    }
  }]);
  return IDGenerator;
}();

var provideIdGenerator = (0, _recompose.withContext)({ idGenerator: _react2.default.PropTypes.object }, function () {
  return { idGenerator: new IDGenerator() };
});

var withIdGenerator = (0, _recompose.getContext)({ idGenerator: _propTypes2.default.object });

exports.withIdGenerator = withIdGenerator;
exports.default = provideIdGenerator;

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(121);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildShopLocation = buildShopLocation;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(68);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRouter = __webpack_require__(60);

var _recompose = __webpack_require__(959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildShopLocation(username, id, from, listIndex) {
  return {
    pathname: '/' + username,
    state: {
      userId: id,
      from: from,
      listIndex: listIndex
    }
  };
}

var ShopLink = function ShopLink(_ref) {
  var user = _ref.user,
      from = _ref.from,
      relay = _ref.relay,
      listIndex = _ref.listIndex,
      props = (0, _objectWithoutProperties3.default)(_ref, ['user', 'from', 'relay', 'listIndex']);
  return _react2.default.createElement(_reactRouter.Link, (0, _extends3.default)({ to: buildShopLocation(user.username, user.publicId, from, listIndex) }, props));
};

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(ShopLink), {
  fragments: {
    user: function user() {
      return function () {
        return {
          children: [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'username',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ShopLink_UserRelayQL',
          type: 'User'
        };
      }();
    }
  }
});

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(274);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(141);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(276);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(Portal, _React$PureComponent);

  function Portal() {
    (0, _classCallCheck3.default)(this, Portal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call(this));

    _this.handleWrapperClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.state.active) {
        return;
      }
      _this.openPortal();
    };

    _this.openPortal = function (props) {
      _this.setState({ active: true });
      _this.renderPortal(props);
      _this.props.onOpen(_this.node);
    };

    _this.closePortal = function () {
      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this.node) {
          _reactDom2.default.unmountComponentAtNode(_this.node);
          document.body.removeChild(_this.node);
        }
        _this.portal = null;
        _this.node = null;
        if (isUnmounted !== true) {
          _this.setState({ active: false });
        }
      };

      if (_this.state.active) {
        if (_this.props.beforeClose) {
          _this.props.beforeClose(_this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        _this.props.onClose();
      }
    };

    _this.handleOutsideMouseClick = function (event) {
      if (!_this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(_this.portal);
      if (root.contains(event.target) || event.button && event.button !== 0) {
        return;
      }

      event.stopPropagation();
      _this.closePortal();
    };

    _this.handleKeydown = function (event) {
      if (event.keyCode === KEYCODES.ESCAPE && _this.state.active) {
        _this.closePortal();
      }
    };

    _this.renderPortal = function (props) {
      if (!_this.node) {
        _this.node = document.createElement('div');
        document.body.appendChild(_this.node);
      }

      var renderFn = props.render;

      _this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, _react2.default.cloneElement(renderFn(), { closePortal: _this.closePortal }), _this.node, _this.props.onUpdate);
    };

    _this.state = { active: false };
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);
  return Portal;
}(_react2.default.PureComponent), _class.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
}, _temp);
exports.default = Portal;

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalShell = exports.Modal = undefined;

var _Modal = __webpack_require__(975);

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalShell = __webpack_require__(976);

var _ModalShell2 = _interopRequireDefault(_ModalShell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Modal = _Modal2.default;
exports.ModalShell = _ModalShell2.default;

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = detectUserMention;
function detectUserMention(input) {
  var spacedInput = input + ' ';
  var userMatch = spacedInput.match('@([a-zA-Z0-9_]+)[:;, ]');
  if (userMatch) {
    return userMatch[1];
  }
  return false;
}

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(989);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1027);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1028);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1029);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1032);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(982);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(962);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1031);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ })

});


// WEBPACK FOOTER //
// 5.6fbbca123039bc6224a7.js